export const idCardType = [
  {"id":"00","name":"无证件"},
  {"id":"05","name":"往来台湾通行证（一次有效）"},
  {"id":"06","name":"台湾居民来往大陆通行证（一次有效）"},
  {"id":"07","name":"台湾居民居住证"},
  {"id":"08","name":"港澳居民居住证"},
  {"id":"0A","name":"非税票据"},
  {"id":"0B","name":"回乡证白卡"},
  {"id":"10","name":"身份证"},
  {"id":"11","name":"外交护照"},
  {"id":"12","name":"公务护照"},
  {"id":"13","name":"因公普通护照"},
  {"id":"14","name":"普通护照"},
  {"id":"15","name":"中华人民共和国旅行证"},
  {"id":"16","name":"台湾居民来往大陆通行证（五年有效）"},
  {"id":"17","name":"海员证"},
  {"id":"20","name":"中华人民共和国出入境通行证"},
  {"id":"21","name":"往来港澳通行证"},
  {"id":"23","name":"前往港澳通行证"},
  {"id":"24","name":"港澳居民来往内地通行证"},
  {"id":"25","name":"往来台湾通行证"},
  {"id":"27","name":"港澳居民定居证"},
  {"id":"28","name":"华侨回国定居证"},
  {"id":"29","name":"台湾居民定居证"},
  {"id":"2F","name":"中华人民共和国出入境通行证（边境旅游专用）"},
  {"id":"30","name":"外国人出入境证"},
  {"id":"31","name":"外国人旅行证"},
  {"id":"32","name":"外国人居留证、居留许可"},
  {"id":"33","name":"外国人临时居留证"},
  {"id":"34","name":"外国人永久居留证"},
  {"id":"35","name":"入籍证书"},
  {"id":"36","name":"出籍证书"},
  {"id":"37","name":"复籍证书"},
  {"id":"3E","name":"特区旅游签证"},
  {"id":"3P","name":"普通签证"},
  {"id":"3T","name":"团体签证"},
  {"id":"49","name":"台湾居民登陆证"},
  {"id":"51","name":"签证身份书"},
  {"id":"60","name":"边境通行证"},
  {"id":"66","name":"回美证"},
  {"id":"70","name":"香港特别行政区护照"},
  {"id":"71","name":"澳门特别行政区护照"},
  {"id":"74","name":"港澳台贴纸签注"},
  {"id":"75","name":"大陆证贴纸签注"},
  {"id":"76","name":"台湾居民居留贴纸签注"},
  {"id":"77","name":"台湾居民来往贴纸签注"},
  {"id":"78","name":"贴纸加注"},
  {"id":"98","name":"转印膜"},
  {"id":"99","name":"其它证件"},
  {"id":"9A","name":"电子护照塑封膜"},
  {"id":"9B","name":"退籍证书"},
  {"id":"9C","name":"复籍证书"},
  {"id":"9D","name":"卡式证件防伪膜"},
  {"id":"9E","name":"2014版塑封膜"},
  {"id":"9F","name":"电子台胞证塑封膜"}
]



export const crjCountyArea = [
  {"id":"ABW","name":"阿鲁巴"},
  {"id":"AFG","name":"阿富汗"},
  {"id":"AGO","name":"安哥拉"},
  {"id":"AIA","name":"安圭拉"},
  {"id":"ALA","name":"奥兰群岛"},
  {"id":"ALB","name":"阿尔巴尼亚"},
  {"id":"AND","name":"安道尔"},
  {"id":"ANT","name":"荷属安的列斯"},
  {"id":"ARE","name":"阿联酋"},
  {"id":"ARG","name":"阿根廷"},
  {"id":"ARM","name":"亚美尼亚"},
  {"id":"ASM","name":"美属萨摩亚"},
  {"id":"ATA","name":"南极洲"},
  {"id":"ATF","name":"法属南部领土"},
  {"id":"ATG","name":"安提瓜和巴布达"},
  {"id":"AUS","name":"澳大利亚"},
  {"id":"AUT","name":"奥地利"},
  {"id":"AZE","name":"阿塞拜疆"},
  {"id":"BDI","name":"布隆迪"},
  {"id":"BEL","name":"比利时"},
  {"id":"BEN","name":"贝宁"},
  {"id":"BFA","name":"布基纳法索"},
  {"id":"BGD","name":"孟加拉国"},
  {"id":"BGR","name":"保加利亚"},
  {"id":"BHR","name":"巴林"},
  {"id":"BHS","name":"巴哈马"},
  {"id":"BIH","name":"波黑"},
  {"id":"BLM","name":"圣巴泰勒米岛"},
  {"id":"BLR","name":"白俄罗斯"},
  {"id":"BLZ","name":"伯利兹"},
  {"id":"BMU","name":"百慕大"},
  {"id":"BOL","name":"玻利维亚"},
  {"id":"BRA","name":"巴西"},
  {"id":"BRB","name":"巴巴多斯"},
  {"id":"BRN","name":"文莱"},
  {"id":"BTN","name":"不丹"},
  {"id":"BVT","name":"布维岛"},
  {"id":"BWA","name":"博茨瓦纳"},
  {"id":"CAF","name":"中非"},
  {"id":"CAN","name":"加拿大"},
  {"id":"CCK","name":"科科斯群岛"},
  {"id":"CHE","name":"瑞士"},
  {"id":"CHL","name":"智利"},
  {"id":"CHN","name":"中国"},
  {"id":"CIV","name":"科特迪瓦"},
  {"id":"CMR","name":"喀麦隆"},
  {"id":"COD","name":"刚果(金)"},
  {"id":"COG","name":"刚果(布)"},
  {"id":"COK","name":"库克群岛"},
  {"id":"COL","name":"哥伦比亚"},
  {"id":"COM","name":"科摩罗"},
  {"id":"CPV","name":"佛得角"},
  {"id":"CRI","name":"哥斯达黎加"},
  {"id":"CUB","name":"古巴"},
  {"id":"CUW","name":"库拉索"},
  {"id":"CXR","name":"圣诞岛"},
  {"id":"CYM","name":"开曼群岛"},
  {"id":"CYP","name":"塞浦路斯"},
  {"id":"CZE","name":"捷克"},
  {"id":"DEU","name":"德国"},
  {"id":"DJI","name":"吉布提"},
  {"id":"DMA","name":"多米尼克"},
  {"id":"DNK","name":"丹麦"},
  {"id":"DOM","name":"多米尼加共和国"},
  {"id":"DZA","name":"阿尔及利亚"},
  {"id":"ECU","name":"厄瓜多尔"},
  {"id":"EGY","name":"埃及"},
  {"id":"ERI","name":"厄立特里亚"},
  {"id":"ESH","name":"西撒哈拉"},
  {"id":"ESP","name":"西班牙"},
  {"id":"EST","name":"爱沙尼亚"},
  {"id":"ETH","name":"埃塞俄比亚"},
  {"id":"FIN","name":"芬兰"},
  {"id":"FJI","name":"斐济"},
  {"id":"FLK","name":"马尔维纳斯群岛"},
  {"id":"FRA","name":"法国"},
  {"id":"FRO","name":"法罗群岛"},
  {"id":"FSM","name":"密克罗尼西亚"},
  {"id":"GAB","name":"加蓬"},
  {"id":"GBD","name":"英国（独立领土公民，出国不用）"},
  {"id":"GBN","name":"英国（海外国民，出国不用）"},
  {"id":"GBO","name":"英国（海外公民，出国不用）"},
  {"id":"GBP","name":"英国（保护公民，出国不用）"},
  {"id":"GBR","name":"英国"},
  {"id":"GBS","name":"英国（隶属，出国不用）"},
  {"id":"GEO","name":"格鲁吉亚"},
  {"id":"GGY","name":"根西岛"},
  {"id":"GHA","name":"加纳"},
  {"id":"GIB","name":"直布罗陀"},
  {"id":"GIN","name":"几内亚"},
  {"id":"GLP","name":"瓜德罗普"},
  {"id":"GMB","name":"冈比亚"},
  {"id":"GNB","name":"几内亚比绍"},
  {"id":"GNQ","name":"赤道几内亚"},
  {"id":"GRC","name":"希腊"},
  {"id":"GRD","name":"格林纳达"},
  {"id":"GRL","name":"格陵兰"},
  {"id":"GTM","name":"危地马拉"},
  {"id":"GUF","name":"法属圭亚那"},
  {"id":"GUM","name":"关岛"},
  {"id":"GUY","name":"圭亚那"},
  {"id":"HKG","name":"香港"},
  {"id":"HMD","name":"赫德岛和麦克唐纳岛"},
  {"id":"HND","name":"洪都拉斯"},
  {"id":"HRV","name":"克罗地亚"},
  {"id":"HTI","name":"海地"},
  {"id":"HUN","name":"匈牙利"},
  {"id":"IDN","name":"印度尼西亚"},
  {"id":"IMN","name":"马恩岛"},
  {"id":"IND","name":"印度"},
  {"id":"IOT","name":"英属印度洋领土"},
  {"id":"IRL","name":"爱尔兰"},
  {"id":"IRN","name":"伊朗"},
  {"id":"IRQ","name":"伊拉克"},
  {"id":"ISL","name":"冰岛"},
  {"id":"ISR","name":"以色列"},
  {"id":"ITA","name":"意大利"},
  {"id":"JAM","name":"牙买加"},
  {"id":"JEY","name":"泽西岛"},
  {"id":"JOR","name":"约旦"},
  {"id":"JPN","name":"日本"},
  {"id":"JTN","name":"约翰斯顿岛"},
  {"id":"KAZ","name":"哈萨克斯坦"},
  {"id":"KEN","name":"肯尼亚"},
  {"id":"KGZ","name":"吉尔吉斯斯坦"},
  {"id":"KHM","name":"柬埔寨"},
  {"id":"KIR","name":"基里巴斯"},
  {"id":"KNA","name":"圣基茨和尼维斯"},
  {"id":"KOR","name":"韩国"},
  {"id":"KWT","name":"科威特"},
  {"id":"LAO","name":"老挝"},
  {"id":"LBN","name":"黎巴嫩"},
  {"id":"LBR","name":"利比里亚"},
  {"id":"LBY","name":"利比亚"},
  {"id":"LCA","name":"圣卢西亚"},
  {"id":"LIE","name":"列支敦士登"},
  {"id":"LKA","name":"斯里兰卡"},
  {"id":"LSO","name":"莱索托"},
  {"id":"LTU","name":"立陶宛"},
  {"id":"LUX","name":"卢森堡"},
  {"id":"LVA","name":"拉脱维亚"},
  {"id":"MAC","name":"澳门"},
  {"id":"MAF","name":"法属圣马丁"},
  {"id":"MAR","name":"摩洛哥"},
  {"id":"MCO","name":"摩纳哥"},
  {"id":"MDA","name":"摩尔多瓦"},
  {"id":"MDG","name":"马达加斯加"},
  {"id":"MDV","name":"马尔代夫"},
  {"id":"MEX","name":"墨西哥"},
  {"id":"MHL","name":"马绍尔群岛"},
  {"id":"MID","name":"中途岛"},
  {"id":"MKD","name":"马其顿"},
  {"id":"MLI","name":"马里"},
  {"id":"MLT","name":"马耳他"},
  {"id":"MMR","name":"缅甸"},
  {"id":"MNE","name":"黑山"},
  {"id":"MNG","name":"蒙古"},
  {"id":"MNP","name":"北马里亚纳"},
  {"id":"MOZ","name":"莫桑比克"},
  {"id":"MRT","name":"毛里塔尼亚"},
  {"id":"MSR","name":"蒙特塞拉特"},
  {"id":"MTQ","name":"马提尼克"},
  {"id":"MUS","name":"毛里求斯"},
  {"id":"MWI","name":"马拉维"},
  {"id":"MYS","name":"马来西亚"},
  {"id":"MYT","name":"马约特"},
  {"id":"NAM","name":"纳米比亚"},
  {"id":"NCL","name":"新喀里多尼亚"},
  {"id":"NER","name":"尼日尔"},
  {"id":"NFK","name":"诺福克岛"},
  {"id":"NGA","name":"尼日利亚"},
  {"id":"NIC","name":"尼加拉瓜"},
  {"id":"NIU","name":"纽埃"},
  {"id":"NLD","name":"荷兰"},
  {"id":"NOR","name":"挪威"},
  {"id":"NPL","name":"尼泊尔"},
  {"id":"NRU","name":"瑙鲁"},
  {"id":"NTZ","name":"中间地带"},
  {"id":"NZL","name":"新西兰"},
  {"id":"OMN","name":"阿曼"},
  {"id":"PAK","name":"巴基斯坦"},
  {"id":"PAN","name":"巴拿马"},
  {"id":"PCN","name":"皮特凯恩"},
  {"id":"PER","name":"秘鲁"},
  {"id":"PHL","name":"菲律宾"},
  {"id":"PLW","name":"帕劳"},
  {"id":"PNG","name":"巴布亚新几内亚"},
  {"id":"POL","name":"波兰"},
  {"id":"PRI","name":"波多黎各"},
  {"id":"PRK","name":"朝鲜"},
  {"id":"PRT","name":"葡萄牙"},
  {"id":"PRY","name":"巴拉圭"},
  {"id":"PST","name":"巴勒斯坦"},
  {"id":"PYF","name":"法属波利尼西亚"},
  {"id":"QAT","name":"卡塔尔"},
  {"id":"REU","name":"留尼汪"},
  {"id":"ROU","name":"罗马尼亚"},
  {"id":"RUS","name":"俄罗斯联邦"},
  {"id":"RWA","name":"卢旺达"},
  {"id":"SAU","name":"沙特阿拉伯"},
  {"id":"SDN","name":"苏丹"},
  {"id":"SEN","name":"塞内加尔"},
  {"id":"SGP","name":"新加坡"},
  {"id":"SGS","name":"南乔治亚岛和南桑德韦奇岛"},
  {"id":"SHN","name":"圣赫勒拿"},
  {"id":"SJM","name":"斯瓦尔巴群岛"},
  {"id":"SLB","name":"所罗门群岛"},
  {"id":"SLE","name":"塞拉利昂"},
  {"id":"SLV","name":"萨尔瓦多"},
  {"id":"SMR","name":"圣马力诺"},
  {"id":"SOM","name":"索马里"},
  {"id":"SPM","name":"圣皮埃尔和密克隆"},
  {"id":"SRB","name":"塞尔维亚"},
  {"id":"SS","name":"塞班"},
  {"id":"SSD","name":"南苏丹"},
  {"id":"STP","name":"圣多美和普林西比"},
  {"id":"SUR","name":"苏里南"},
  {"id":"SVK","name":"斯洛伐克"},
  {"id":"SVN","name":"斯洛文尼亚"},
  {"id":"SWE","name":"瑞典"},
  {"id":"SWZ","name":"斯威士兰"},
  {"id":"SX","name":"锡金"},
  {"id":"SXM","name":"荷属圣马丁"},
  {"id":"SYC","name":"塞舌尔"},
  {"id":"SYR","name":"叙利亚"},
  {"id":"TCA","name":"特克斯和凯科斯群岛"},
  {"id":"TCD","name":"乍得"},
  {"id":"TGO","name":"多哥"},
  {"id":"THA","name":"泰国"},
  {"id":"TJK","name":"塔吉克斯坦"},
  {"id":"TKL","name":"托克劳"},
  {"id":"TKM","name":"土库曼斯坦"},
  {"id":"TLS","name":"东帝汶"},
  {"id":"TON","name":"汤加"},
  {"id":"TTO","name":"特立尼达和多巴哥"},
  {"id":"TUN","name":"突尼斯"},
  {"id":"TUR","name":"土耳其"},
  {"id":"TUV","name":"图瓦卢"},
  {"id":"TWN","name":"台湾"},
  {"id":"TZA","name":"坦桑尼亚"},
  {"id":"UGA","name":"乌干达"},
  {"id":"UKR","name":"乌克兰"},
  {"id":"UMI","name":"美国本土外小岛屿"},
  {"id":"UN","name":"联合国"},
  {"id":"UNA","name":"联合国"},
  {"id":"UNO","name":"联合国"},
  {"id":"URY","name":"乌拉圭"},
  {"id":"USA","name":"美国"},
  {"id":"UZB","name":"乌兹别克斯坦"},
  {"id":"VAT","name":"梵蒂冈"},
  {"id":"VCT","name":"圣文森特和格林纳丁斯"},
  {"id":"VEN","name":"委内瑞拉"},
  {"id":"VGB","name":"英属维尔京群岛"},
  {"id":"VIR","name":"美属维尔京群岛"},
  {"id":"VNM","name":"越南"},
  {"id":"VUT","name":"瓦努阿图"},
  {"id":"WAK","name":"威克岛"},
  {"id":"WLF","name":"瓦利斯和富图纳群岛"},
  {"id":"WSM","name":"萨摩亚"},
  {"id":"XXA","name":"无国籍"},
  {"id":"XXB","name":"被联合国承认的难民"},
  {"id":"XXC","name":"不被联合国承认的难民"},
  {"id":"XXX","name":"国籍不明"},
  {"id":"YEM","name":"也门"},
  {"id":"YKS","name":"科索沃"},
  {"id":"YUG","name":"南斯拉夫"},
  {"id":"ZAF","name":"南非"},
  {"id":"ZAR","name":"扎伊尔"},
  {"id":"ZMB","name":"赞比亚"},
  {"id":"ZWE","name":"津巴布韦"},
  {"id":"ZZZ","name":"国籍不详"}
]

export const areaType = [
  {"id":"C","name":"华侨"},
  {"id":"E","name":"港澳居民"},
  {"id":"F","name":"外国人"},
  {"id":"H","name":"香港居民"},
  {"id":"M","name":"澳门居民"},
  {"id":"O","name":"外籍华人"},
  {"id":"R","name":"内地居民"},
  {"id":"T","name":"台湾居民"}
]

export const sex = [
  {"id":"0","name":"未知"},
  {"id":"1","name":"男"},
  {"id":"2","name":"女"},
  {"id":"9","name":"未说明"}
]

export const crjCardType = [
  {"id":"A","name":"长期学习签证(X1)"},
  {"id":"B","name":"短期学习签证(X2)"},
  {"id":"C","name":"乘务签证(C)"},
  {"id":"D","name":"定居签证(D)"},
  {"id":"E","name":"特区旅游签证(E)"},
  {"id":"F","name":"访问签证(F)"},
  {"id":"G","name":"过境签证(G)"},
  {"id":"H","name":"短期团聚签证(Q2)"},
  {"id":"I","name":"绿卡（外国人人永久居留证）(I)"},
  {"id":"J","name":"常住记者签证(J1)"},
  {"id":"K","name":"长期团聚签证(Q1)"},
  {"id":"L","name":"旅游签证(L)"},
  {"id":"M","name":"免办签证(MQ)"},
  {"id":"N","name":"长期私人事务签证(S1)"},
  {"id":"O","name":"短期私人事务签证(S2)"},
  {"id":"P","name":"临时来华记者签证(J2)"},
  {"id":"Q","name":"其他(Q)"},
  {"id":"R","name":"居留证件(JL)"},
  {"id":"S","name":"APEC商务旅行卡(S)"},
  {"id":"T","name":"团体签证(T)"},
  {"id":"U","name":"公务签证(U)"},
  {"id":"V","name":"无签证"},
  {"id":"W","name":"外交签证(W)"},
  {"id":"Y","name":"礼遇签证(Y)"},
  {"id":"Z","name":"工作签证(Z)"},
  {"id":"m","name":"贸易签证(M)"},
  {"id":"r","name":"人才签证(R)"},
  {"id":"t","name":"停留证件(TL)"},
  {"id":"y","name":"签证延期(YQ)"}
]

export const residentialPoliceStation = [
  {"id":"420102300000","name":"谌家矶街派出所"},
  {"id":"420102310000","name":"后湖乡派出所"},
  {"id":"420102320000","name":"百步亭派出所"},
  {"id":"420102610000","name":"大智街派出所"},
  {"id":"420102620000","name":"上海街派出所"},
  {"id":"420102630000","name":"一元街派出所"},
  {"id":"420102640000","name":"车站街派出所"},
  {"id":"420102650000","name":"四唯街派出所"},
  {"id":"420102660000","name":"永清街派出所"},
  {"id":"420102670000","name":"西马街派出所"},
  {"id":"420102680000","name":"球场街派出所"},
  {"id":"420102690000","name":"劳动街派出所"},
  {"id":"420102700000","name":"二七街派出所"},
  {"id":"420102710000","name":"新村街派出所"},
  {"id":"420102720000","name":"丹水池街派出所"},
  {"id":"420102730000","name":"台北街派出所"},
  {"id":"420102740000","name":"花桥街花桥派出所"},
  {"id":"420102750000","name":"花桥街竹叶山派出所"},
  {"id":"420102760000","name":"谌家矶街派出所"},
  {"id":"420102770000","name":"后湖街后湖派出所"},
  {"id":"420102780000","name":"塔子湖街派出所"},
  {"id":"420102790000","name":"百步亭派出所"},
  {"id":"420103150000","name":"花楼街派出所"},
  {"id":"420103160000","name":"民权街派出所"},
  {"id":"420103170000","name":"民族街派出所"},
  {"id":"420103180000","name":"满春街派出所"},
  {"id":"420103190000","name":"水塔街派出所"},
  {"id":"420103200000","name":"前进街派出所"},
  {"id":"420103210000","name":"民意街派出所"},
  {"id":"420103220000","name":"新华街派出所"},
  {"id":"420103230000","name":"万松街派出所"},
  {"id":"420103240000","name":"北湖街派出所"},
  {"id":"420103250000","name":"唐家墩街派出所"},
  {"id":"420103260000","name":"常青街派出所"},
  {"id":"420103270000","name":"汉兴街派出所"},
  {"id":"420103280000","name":"王家墩机场派出所"},
  {"id":"420103290000","name":"汉口车站派出所"},
  {"id":"420103300000","name":"东汉正街市场派出所"},
  {"id":"420103310000","name":"中展派出所"},
  {"id":"420103320000","name":"江汉经济开发区派出所"},
  {"id":"420103610000","name":"花楼街派出所"},
  {"id":"420103620000","name":"民权街派出所"},
  {"id":"420103630000","name":"民族街派出所"},
  {"id":"420103640000","name":"满春街派出所"},
  {"id":"420103650000","name":"水塔街派出所"},
  {"id":"420103660000","name":"前进街派出所"},
  {"id":"420103670000","name":"民意街派出所"},
  {"id":"420103680000","name":"新华街派出所"},
  {"id":"420103690000","name":"万松街派出所"},
  {"id":"420103700000","name":"北湖街派出所"},
  {"id":"420103710000","name":"唐家墩街派出所"},
  {"id":"420103720000","name":"常青街派出所"},
  {"id":"420103730000","name":"汉兴街派出所"},
  {"id":"420103740000","name":"江汉经济开发区派出所"},
  {"id":"420103750000","name":"王家墩派出所"},
  {"id":"420103760000","name":"汉口车站派出所"},
  {"id":"420103770000","name":"汉兴街姑嫂树派出所"},
  {"id":"420103780000","name":"中展派出所"},
  {"id":"420103790000","name":"江汉分局汉口客运站派出所"},
  {"id":"420104150000","name":"易家墩街派出所"},
  {"id":"420104160000","name":"韩家墩街派出所"},
  {"id":"420104170000","name":"宗关街宗关派出所"},
  {"id":"420104180000","name":"宗关街发展派出所"},
  {"id":"420104200000","name":"宝丰街派出所"},
  {"id":"420104210000","name":"荣华街派出所"},
  {"id":"420104220000","name":"崇仁街派出所"},
  {"id":"420104230000","name":"汉中街派出所"},
  {"id":"420104240000","name":"汉正街利济派出所"},
  {"id":"420104260000","name":"汉正街新安派出所"},
  {"id":"420104270000","name":"六角亭街派出所"},
  {"id":"420104280000","name":"长丰乡派出所"},
  {"id":"420104610000","name":"古田街派出所"},
  {"id":"420104620000","name":"韩家墩街派出所"},
  {"id":"420104630000","name":"宗关街宗关派出所"},
  {"id":"420104640000","name":"长丰街发展派出所"},
  {"id":"420104650000","name":"汉水桥街派出所"},
  {"id":"420104660000","name":"宝丰街派出所"},
  {"id":"420104670000","name":"荣华街派出所"},
  {"id":"420104690000","name":"汉中街派出所"},
  {"id":"420104700000","name":"汉正街利济派出所"},
  {"id":"420104710000","name":"汉正街三曙派出所"},
  {"id":"420104720000","name":"汉正街新安派出所"},
  {"id":"420104730000","name":"六角亭街派出所"},
  {"id":"420104740000","name":"长丰街派出所"},
  {"id":"420104750000","name":"汉正街市场派出所"},
  {"id":"420104760000","name":"易家街派出所"},
  {"id":"420105150000","name":"建桥街派出所"},
  {"id":"420105160000","name":"翠微街派出所"},
  {"id":"420105170000","name":"晴川街派出所"},
  {"id":"420105190000","name":"月湖街派出所"},
  {"id":"420105200000","name":"鹦鹉街派出所"},
  {"id":"420105210000","name":"洲头街派出所"},
  {"id":"420105220000","name":"江汉二桥街派出所"},
  {"id":"420105230000","name":"永丰乡派出所"},
  {"id":"420105250000","name":"江堤乡派出所"},
  {"id":"420105260000","name":"四新派出所"},
  {"id":"420105270000","name":"军山街派出所"},
  {"id":"420105610000","name":"建桥街派出所"},
  {"id":"420105620000","name":"翠微街派出所"},
  {"id":"420105630000","name":"晴川街派出所"},
  {"id":"420105640000","name":"五里墩街派出所"},
  {"id":"420105650000","name":"月湖街派出所"},
  {"id":"420105660000","name":"鹦鹉街派出所"},
  {"id":"420105670000","name":"洲头街派出所"},
  {"id":"420105680000","name":"江汉二桥街派出所"},
  {"id":"420105690000","name":"永丰街派出所"},
  {"id":"420105700000","name":"琴断口街派出所"},
  {"id":"420105710000","name":"江堤街派出所"},
  {"id":"420105720000","name":"四新派出所"},
  {"id":"420105730000","name":"江北派出所"},
  {"id":"420105740000","name":"汉阳经济开发区派出所"},
  {"id":"420106150000","name":"杨园街派出所"},
  {"id":"420106160000","name":"徐家棚街派出所"},
  {"id":"420106190000","name":"中华路街派出所"},
  {"id":"420106200000","name":"粮道街派出所"},
  {"id":"420106210000","name":"黄鹤楼街派出所"},
  {"id":"420106220000","name":"首义路街派出所"},
  {"id":"420106230000","name":"紫阳路街派出所"},
  {"id":"420106250000","name":"中南路街中南派出所"},
  {"id":"420106270000","name":"水果湖街水果湖派出所"},
  {"id":"420106280000","name":"水果湖街东亭派出所"},
  {"id":"420106290000","name":"南湖街派出所"},
  {"id":"420106300000","name":"石洞街派出所"},
  {"id":"420106310000","name":"站前派出所"},
  {"id":"420106320000","name":"中南路街梅苑派出所"},
  {"id":"420106610000","name":"杨园街派出所"},
  {"id":"420106620000","name":"徐家棚街派出所"},
  {"id":"420106630000","name":"积玉桥街派出所"},
  {"id":"420106640000","name":"中华路街派出所"},
  {"id":"420106650000","name":"粮道街派出所"},
  {"id":"420106660000","name":"黄鹤楼街派出所"},
  {"id":"420106670000","name":"首义路街派出所"},
  {"id":"420106680000","name":"紫阳路街派出所"},
  {"id":"420106690000","name":"白沙洲街派出所"},
  {"id":"420106700000","name":"中南路街中南路派出所"},
  {"id":"420106710000","name":"中南路街梅苑派出所"},
  {"id":"420106720000","name":"珞珈山街派出所"},
  {"id":"420106730000","name":"水果湖街水果湖派出所"},
  {"id":"420106740000","name":"水果湖街东亭派出所"},
  {"id":"420106750000","name":"南湖街派出所"},
  {"id":"420106760000","name":"石洞街派出所"},
  {"id":"420106770000","name":"站前派出所"},
  {"id":"420106780000","name":"武泰闸市场派出所"},
  {"id":"420106790000","name":"武昌客运站派出所"},
  {"id":"420106800000","name":"双湖派出所"},
  {"id":"420106820000","name":"凤凰山派出所"},
  {"id":"420106830000","name":"余家头派出所"},
  {"id":"420107150000","name":"红卫路街派出所"},
  {"id":"420107160000","name":"钢花村街派出所"},
  {"id":"420107170000","name":"钢都花园派出所"},
  {"id":"420107180000","name":"冶金街派出所"},
  {"id":"420107190000","name":"新沟桥街派出所"},
  {"id":"420107200000","name":"红钢城街派出所"},
  {"id":"420107210000","name":"工人村街派出所"},
  {"id":"420107220000","name":"青山镇街派出所"},
  {"id":"420107230000","name":"厂前街派出所"},
  {"id":"420107240000","name":"武东街派出所"},
  {"id":"420107250000","name":"白玉山街派出所"},
  {"id":"420107260000","name":"八大家派出所"},
  {"id":"420107270000","name":"凤凰派出所"},
  {"id":"420107610000","name":"红卫路街派出所"},
  {"id":"420107620000","name":"钢花村街派出所"},
  {"id":"420107630000","name":"钢都花园派出所"},
  {"id":"420107640000","name":"冶金街派出所"},
  {"id":"420107650000","name":"新沟桥街派出所"},
  {"id":"420107660000","name":"红钢城街派出所"},
  {"id":"420107670000","name":"工人村街派出所"},
  {"id":"420107680000","name":"青山镇街派出所"},
  {"id":"420107690000","name":"厂前街派出所"},
  {"id":"420107700000","name":"武东街派出所"},
  {"id":"420107710000","name":"白玉山街派出所"},
  {"id":"420107720000","name":"八大家派出所"},
  {"id":"420107730000","name":"凤凰派出所"},
  {"id":"420107740000","name":"冶炼派出所"},
  {"id":"420107750000","name":"石山派出所"},
  {"id":"420107760000","name":"工业港派出所"},
  {"id":"420107770000","name":"青化派出所"},
  {"id":"420107780000","name":"轧钢派出所"},
  {"id":"420111150000","name":"洪山乡派出所"},
  {"id":"420111160000","name":"青菱乡（张家湾街）派出所"},
  {"id":"420111170000","name":"狮子山街派出所"},
  {"id":"420111180000","name":"珞南街珞南派出所"},
  {"id":"420111190000","name":"珞南街卓刀泉派出所"},
  {"id":"420111200000","name":"关山街派出所"},
  {"id":"420111210000","name":"九峰乡派出所"},
  {"id":"420111220000","name":"花山镇派出所"},
  {"id":"420111230000","name":"左岭镇派出所"},
  {"id":"420111240000","name":"葛化街派出所"},
  {"id":"420111250000","name":"和平乡（红旗街）和平派出所"},
  {"id":"420111260000","name":"和平乡（红旗街）徐东派出所"},
  {"id":"420111270000","name":"建设乡派出所"},
  {"id":"420111280000","name":"天兴洲乡派出所"},
  {"id":"420111290000","name":"白沙洲市场派出所"},
  {"id":"420111300000","name":"同心派出所"},
  {"id":"420111620000","name":"洪山街洪山派出所"},
  {"id":"420111630000","name":"洪山街北港派出所"},
  {"id":"420111640000","name":"张家湾街派出所"},
  {"id":"420111650000","name":"狮子山街派出所"},
  {"id":"420111660000","name":"珞南街派出所"},
  {"id":"420111670000","name":"卓刀泉街派出所"},
  {"id":"420111680000","name":"关山街派出所"},
  {"id":"420111720000","name":"和平街派出所"},
  {"id":"420111730000","name":"梨园街派出所"},
  {"id":"420111750000","name":"天兴乡派出所"},
  {"id":"420111760000","name":"白沙洲市场派出所"},
  {"id":"420111770000","name":"武汉火车站派出所"},
  {"id":"420111780000","name":"马房山派出所"},
  {"id":"420111790000","name":"喻家山派出所"},
  {"id":"420111800000","name":"南湖派出所"},
  {"id":"420111810000","name":"青菱街派出所"},
  {"id":"420112130000","name":"新村街派出所"},
  {"id":"420112140000","name":"吴家山派出所"},
  {"id":"420112150000","name":"慈惠派出所"},
  {"id":"420112160000","name":"走马岭派出所"},
  {"id":"420112170000","name":"新沟农场派出所"},
  {"id":"420112180000","name":"荷包湖派出所"},
  {"id":"420112190000","name":"新沟镇派出所"},
  {"id":"420112200000","name":"东山派出所"},
  {"id":"420112210000","name":"径河派出所"},
  {"id":"420112220000","name":"柏泉派出所"},
  {"id":"420112230000","name":"李家墩派出所"},
  {"id":"420112240000","name":"三店派出所"},
  {"id":"420112250000","name":"辛安渡派出所"},
  {"id":"420112260000","name":"常青花园派出所"},
  {"id":"420112270000","name":"舵落口市场派出所"},
  {"id":"420112280000","name":"金银湖派出所"},
  {"id":"420112610000","name":"吴家山街派出所"},
  {"id":"420112620000","name":"长青街派出所"},
  {"id":"420112630000","name":"慈惠派出所"},
  {"id":"420112640000","name":"走马岭派出所"},
  {"id":"420112650000","name":"新沟派出所"},
  {"id":"420112660000","name":"荷包湖派出所"},
  {"id":"420112670000","name":"新沟镇派出所"},
  {"id":"420112680000","name":"东山派出所"},
  {"id":"420112690000","name":"径河派出所"},
  {"id":"420112700000","name":"柏泉派出所"},
  {"id":"420112710000","name":"李家墩派出所"},
  {"id":"420112720000","name":"三店派出所"},
  {"id":"420112730000","name":"辛安渡派出所"},
  {"id":"420112740000","name":"常青花园派出所"},
  {"id":"420112750000","name":"舵落口市场派出所"},
  {"id":"420112760000","name":"金银湖派出所"},
  {"id":"420113090000","name":"东荆街派出所"},
  {"id":"420113100000","name":"纱帽街街派出所"},
  {"id":"420113110000","name":"邓南镇派出所"},
  {"id":"420113120000","name":"湘口街派出所"},
  {"id":"420114120000","name":"蔡甸街蔡甸派出所"},
  {"id":"420114130000","name":"蔡甸街新农派出所"},
  {"id":"420114140000","name":"大集街派出所"},
  {"id":"420114150000","name":"奓山街派出所"},
  {"id":"420114170000","name":"永安街派出所"},
  {"id":"420114180000","name":"侏儒街派出所"},
  {"id":"420114190000","name":"张湾街派出所"},
  {"id":"420114200000","name":"索河镇派出所"},
  {"id":"420114210000","name":"玉贤镇派出所"},
  {"id":"420114220000","name":"消泗乡派出所"},
  {"id":"420114230000","name":"蔡甸经济开发区派出所"},
  {"id":"420114610000","name":"蔡甸街蔡甸派出所"},
  {"id":"420114620000","name":"蔡甸街新农派出所"},
  {"id":"420114630000","name":"大集街派出所"},
  {"id":"420114640000","name":"奓山街派出所"},
  {"id":"420114650000","name":"永安街派出所"},
  {"id":"420114660000","name":"侏儒街派出所"},
  {"id":"420114670000","name":"张湾街派出所"},
  {"id":"420114680000","name":"索河镇派出所"},
  {"id":"420114690000","name":"玉贤镇派出所"},
  {"id":"420114700000","name":"消泗乡派出所"},
  {"id":"420114710000","name":"蔡甸经济开发区派出所"},
  {"id":"420115120000","name":"纸坊街纸坊派出所"},
  {"id":"420115130000","name":"纸坊街大桥派出所"},
  {"id":"420115140000","name":"金口街派出所"},
  {"id":"420115150000","name":"乌龙泉街派出所"},
  {"id":"420115160000","name":"流芳街派出所"},
  {"id":"420115170000","name":"郑店街派出所"},
  {"id":"420115180000","name":"豹澥镇派出所"},
  {"id":"420115190000","name":"五里界镇派出所"},
  {"id":"420115200000","name":"山坡乡派出所"},
  {"id":"420115210000","name":"安山镇派出所"},
  {"id":"420115220000","name":"法泗镇派出所"},
  {"id":"420115230000","name":"湖泗镇派出所"},
  {"id":"420115240000","name":"舒安乡派出所"},
  {"id":"420115260000","name":"庙山派出所"},
  {"id":"420115270000","name":"藏龙岛派出所"},
  {"id":"420115610000","name":"纸坊街纸坊派出所"},
  {"id":"420115620000","name":"纸坊街大桥派出所"},
  {"id":"420115630000","name":"金口街派出所"},
  {"id":"420115640000","name":"乌龙泉街派出所"},
  {"id":"420115660000","name":"郑店街派出所"},
  {"id":"420115670000","name":"五里界街派出所"},
  {"id":"420115680000","name":"山坡乡派出所"},
  {"id":"420115690000","name":"安山镇派出所"},
  {"id":"420115700000","name":"法泗镇派出所"},
  {"id":"420115710000","name":"湖泗镇派出所"},
  {"id":"420115720000","name":"舒安乡派出所"},
  {"id":"420115730000","name":"机场派出所"},
  {"id":"420115740000","name":"庙山派出所"},
  {"id":"420115750000","name":"藏龙岛派出所"},
  {"id":"420115760000","name":"金港派出所"},
  {"id":"420116120000","name":"前川街前川派出所"},
  {"id":"420116130000","name":"前川街环城派出所"},
  {"id":"420116150000","name":"王家河镇派出所"},
  {"id":"420116160000","name":"蔡家榨镇派出所"},
  {"id":"420116170000","name":"六指街派出所"},
  {"id":"420116180000","name":"盘龙城经济开发区派出所"},
  {"id":"420116190000","name":"滠口街派出所"},
  {"id":"420116210000","name":"天河街派出所"},
  {"id":"420116220000","name":"三里镇派出所"},
  {"id":"420116230000","name":"武湖派出所"},
  {"id":"420116240000","name":"罗汉寺街派出所"},
  {"id":"420116250000","name":"李家集镇派出所"},
  {"id":"420116270000","name":"蔡店乡派出所"},
  {"id":"420116280000","name":"姚家集镇派出所"},
  {"id":"420116290000","name":"长轩岭镇派出所"},
  {"id":"420116300000","name":"木兰乡派出所"},
  {"id":"420116310000","name":"木兰山风景区派出所"},
  {"id":"420116610000","name":"前川街前川派出所"},
  {"id":"420116620000","name":"前川街环城派出所"},
  {"id":"420116630000","name":"团山派出所"},
  {"id":"420116640000","name":"王家河街派出所"},
  {"id":"420116650000","name":"蔡家榨镇派出所"},
  {"id":"420116660000","name":"六指街派出所"},
  {"id":"420116670000","name":"盘龙城经济开发区派出所"},
  {"id":"420116680000","name":"滠口街派出所"},
  {"id":"420116690000","name":"横店街派出所"},
  {"id":"420116700000","name":"天河街派出所"},
  {"id":"420116710000","name":"三里镇派出所"},
  {"id":"420116720000","name":"武湖派出所"},
  {"id":"420116730000","name":"罗汉寺街派出所"},
  {"id":"420116740000","name":"李家集镇派出所"},
  {"id":"420116750000","name":"祁家湾街派出所"},
  {"id":"420116760000","name":"蔡店乡派出所"},
  {"id":"420116770000","name":"姚家集镇派出所"},
  {"id":"420116780000","name":"长轩岭街派出所"},
  {"id":"420116790000","name":"木兰乡派出所"},
  {"id":"420116800000","name":"木兰山风景区派出所"},
  {"id":"420117130000","name":"邾城街刘集派出所"},
  {"id":"420117140000","name":"阳逻街派出所"},
  {"id":"420117150000","name":"阳逻经济开发区派出所"},
  {"id":"420117160000","name":"仓埠街派出所"},
  {"id":"420117170000","name":"辛冲镇派出所"},
  {"id":"420117180000","name":"旧街街派出所"},
  {"id":"420117200000","name":"潘塘街派出所"},
  {"id":"420117210000","name":"三店街派出所"},
  {"id":"420117220000","name":"凤凰镇派出所"},
  {"id":"420117230000","name":"李集街派出所"},
  {"id":"420117240000","name":"汪集街派出所"},
  {"id":"420117250000","name":"双柳街派出所"},
  {"id":"420117260000","name":"道观河派出所"},
  {"id":"420117610000","name":"邾城街邾城派出所"},
  {"id":"420117620000","name":"邾城街刘集派出所"},
  {"id":"420117630000","name":"阳逻街派出所"},
  {"id":"420117640000","name":"阳逻经济开发区派出所"},
  {"id":"420117650000","name":"仓埠街派出所"},
  {"id":"420117660000","name":"辛冲镇派出所"},
  {"id":"420117670000","name":"旧街街派出所"},
  {"id":"420117680000","name":"徐古镇派出所"},
  {"id":"420117690000","name":"潘塘街派出所"},
  {"id":"420117700000","name":"三店街派出所"},
  {"id":"420117710000","name":"凤凰镇派出所"},
  {"id":"420117720000","name":"李集街派出所"},
  {"id":"420117730000","name":"汪集街派出所"},
  {"id":"420117740000","name":"双柳街派出所"},
  {"id":"420117750000","name":"道观河派出所"},
  {"id":"420182610000","name":"王家巷派出所"},
  {"id":"420182620000","name":"龙王庙派出所"},
  {"id":"420182630000","name":"杨家河派出所"},
  {"id":"420182640000","name":"大桥派出所"},
  {"id":"420182650000","name":"青山派出所"},
  {"id":"420182660000","name":"月亮湾派出所"},
  {"id":"420182670000","name":"长江二桥派出所"},
  {"id":"420182680000","name":"建港派出所"},
  {"id":"420182690000","name":"舵落口派出所"},
  {"id":"420182700000","name":"白浒山派出所"},
  {"id":"420184610000","name":"沌阳派出所"},
  {"id":"420184620000","name":"神龙派出所"},
  {"id":"420184630000","name":"沌口派出所"},
  {"id":"420184640000","name":"薛峰派出所"},
  {"id":"420184650000","name":"军山街派出所"},
  {"id":"420184660000","name":"湖滨派出所"},
  {"id":"420184670000","name":"纱帽街派出所"},
  {"id":"420184680000","name":"东荆街派出所"},
  {"id":"420184690000","name":"邓南街派出所"},
  {"id":"420184700000","name":"湘口街派出所"},
  {"id":"420185610000","name":"关东派出所"},
  {"id":"420185620000","name":"关南派出所"},
  {"id":"420185630000","name":"茅店派出所"},
  {"id":"420185640000","name":"同心派出所"},
  {"id":"420185650000","name":"豹澥派出所"},
  {"id":"420185660000","name":"九峰派出所"},
  {"id":"420185670000","name":"花山镇派出所"},
  {"id":"420185680000","name":"左岭镇派出所"},
  {"id":"420185690000","name":"葛化街派出所"},
  {"id":"420185700000","name":"龙泉街派出所"},
  {"id":"420185710000","name":"铁箕山派出所"},
  {"id":"420185720000","name":"滨湖派出所"},
  {"id":"420186610000","name":"听涛派出所"},
  {"id":"420186620000","name":"磨山派出所"},
  {"id":"420186630000","name":"落雁派出所"},
  {"id":"420186640000","name":"吹笛派出所"},
  {"id":"420186650000","name":"水上派出所"},
  {"id":"420186660000","name":"湖光派出所"},
  {"id":"420188650000","name":"轨道交通管理分局轻轨派出所"},
  {"id":"420188660000","name":"轨道交通管理分局街道口派出所"},
  {"id":"420197000003","name":"茅店派出所"},
  {"id":"420198000001","name":"听涛派出所"},
  {"id":"420198000002","name":"磨山派出所"},
  {"id":"420198000003","name":"落雁派出所"},
  {"id":"420198000004","name":"吹笛派出所"},
  {"id":"420202090000","name":"黄石港派出所"},
  {"id":"420202100000","name":"沈家营派出所"},
  {"id":"420202110000","name":"红旗桥派出所"},
  {"id":"420202120000","name":"胜阳港派出所"},
  {"id":"420202130000","name":"黄石港水上派出所"},
  {"id":"420203090000","name":"黄思湾派出所"},
  {"id":"420203100000","name":"临江派出所"},
  {"id":"420203110000","name":"八泉派出所"},
  {"id":"420203120000","name":"陈家湾派出所"},
  {"id":"420203130000","name":"澄月派出所"},
  {"id":"420203140000","name":"河口派出所"},
  {"id":"420203150000","name":"西塞派出所"},
  {"id":"420203160000","name":"江北派出所"},
  {"id":"420203170000","name":"西塞山水上派出所"},
  {"id":"420204130000","name":"老下陆派出所"},
  {"id":"420204140000","name":"新下陆派出所"},
  {"id":"420204150000","name":"东方乡派出所"},
  {"id":"420204160000","name":"肖铺乡派出所"},
  {"id":"420204170000","name":"团城山派出所"},
  {"id":"420205110000","name":"铁山派出所"},
  {"id":"420205120000","name":"盛洪卿派出所"},
  {"id":"420205130000","name":"鹿獐山派出所"},
  {"id":"420205140000","name":"九龙派出所"},
  {"id":"420222130000","name":"上街派出所"},
  {"id":"420222140000","name":"西门派出所"},
  {"id":"420222150000","name":"太子中心派出所"},
  {"id":"420222160000","name":"韦源口派出所"},
  {"id":"420222170000","name":"大王派出所"},
  {"id":"420222180000","name":"黄颡口派出所"},
  {"id":"420222190000","name":"金海派出所"},
  {"id":"420222200000","name":"富池中心派出所"},
  {"id":"420222210000","name":"陶港派出所"},
  {"id":"420222220000","name":"鸡笼山派出所"},
  {"id":"420222230000","name":"富水派出所"},
  {"id":"420222240000","name":"枫林中心派出所"},
  {"id":"420222250000","name":"木港派出所"},
  {"id":"420222260000","name":"排市派出所"},
  {"id":"420222270000","name":"三溪中心派出所"},
  {"id":"420222280000","name":"浮屠街派出所"},
  {"id":"420222290000","name":"白沙派出所"},
  {"id":"420222300000","name":"王英派出所"},
  {"id":"420222310000","name":"龙港中心派出所"},
  {"id":"420222320000","name":"洋港派出所"},
  {"id":"420281190000","name":"东风路派出所"},
  {"id":"420281190100","name":"东风路派出所刑侦中队"},
  {"id":"420281200000","name":"东岳路派出所"},
  {"id":"420281200100","name":"东岳路派出所刑侦中队"},
  {"id":"420281200200","name":"东岳路派出所四棵警务区"},
  {"id":"420281210000","name":"大箕铺派出所"},
  {"id":"420281210100","name":"大箕铺派出所刑侦中队"},
  {"id":"420281220000","name":"金湖派出所"},
  {"id":"420281220100","name":"金湖派出所刑侦中队"},
  {"id":"420281230000","name":"殷祖派出所"},
  {"id":"420281230100","name":"殷祖派出所刑侦中队"},
  {"id":"420281240000","name":"刘仁八派出所"},
  {"id":"420281240100","name":"刘仁八派出所刑侦中队"},
  {"id":"420281250000","name":"金牛派出所"},
  {"id":"420281250100","name":"金牛派出所刑侦中队"},
  {"id":"420281250200","name":"金牛派出所高河警务区"},
  {"id":"420281260000","name":"灵乡派出所"},
  {"id":"420281260100","name":"灵乡派出所刑侦中队"},
  {"id":"420281260200","name":"灵乡派出所毛铺警务区"},
  {"id":"420281270000","name":"茗山派出所"},
  {"id":"420281270100","name":"茗山派出所刑侦中队"},
  {"id":"420281280000","name":"陈贵派出所"},
  {"id":"420281280100","name":"陈贵派出所刑侦中队"},
  {"id":"420281280200","name":"陈贵派出所铜山口警务区"},
  {"id":"420281290000","name":"金山店派出所"},
  {"id":"420281290100","name":"金山店派出所刑侦中队"},
  {"id":"420281300000","name":"保安派出所"},
  {"id":"420281300100","name":"保安派出所刑侦中队"},
  {"id":"420281310000","name":"还地桥派出所"},
  {"id":"420281310100","name":"还地桥派出所刑侦中队"},
  {"id":"420281310200","name":"还地桥派出所曙光警务区"},
  {"id":"420281310300","name":"还地桥派出所东风农场警务区"},
  {"id":"420281310400","name":"还地桥派出所黄金湖警务区"},
  {"id":"420281320000","name":"罗家桥派出所"},
  {"id":"420281320100","name":"罗家桥派出所刑侦中队"},
  {"id":"420281330100","name":"汪仁派出所刑侦中队"},
  {"id":"420296090000","name":"团城山派出所"},
  {"id":"420296100000","name":"花湖派出所"},
  {"id":"420296110000","name":"大桥派出所"},
  {"id":"420302060000","name":"朝阳路派出所"},
  {"id":"420302070000","name":"人民路派出所"},
  {"id":"420302080000","name":"武当路派出所"},
  {"id":"420302080101","name":"湖北省十堰市公安局茅箭区分局朝阳路派出所五堰北街社区警务室"},
  {"id":"420302080102","name":"湖北省十堰市公安局茅箭区分局朝阳路派出所柳林新村社区警务室"},
  {"id":"420302080103","name":"湖北省十堰市公安局茅箭区分局朝阳路派出所东岳社区警务室"},
  {"id":"420302080104","name":"湖北省十堰市公安局茅箭区分局朝阳路派出所滨河社区警务室"},
  {"id":"420302080105","name":"湖北省十堰市公安局茅箭区分局朝阳路派出所六堰山社区警务室"},
  {"id":"420302080106","name":"湖北省十堰市公安局茅箭区分局朝阳路派出所李家岗村警务室"},
  {"id":"420302080107","name":"湖北省十堰市公安局茅箭区分局朝阳路派出所朝阳社区警务室"},
  {"id":"420302080108","name":"湖北省十堰市公安局茅箭区分局朝阳路派出所四堰社区警务室"},
  {"id":"420302080109","name":"湖北省十堰市公安局茅箭区分局朝阳路派出所燕林社区警务室"},
  {"id":"420302080110","name":"湖北省十堰市公安局茅箭区分局朝阳路派出所南街社区警务室"},
  {"id":"420302090000","name":"白浪派出所"},
  {"id":"420302090101","name":"湖北省十堰市公安局茅箭区分局人民路派出所垭子社区警务室"},
  {"id":"420302090102","name":"湖北省十堰市公安局茅箭区分局人民路派出所火车站社区警务室"},
  {"id":"420302090103","name":"湖北省十堰市公安局茅箭区分局人民路派出所源园警社区务室"},
  {"id":"420302090104","name":"湖北省十堰市公安局茅箭区分局人民路派出所老街社区警务室"},
  {"id":"420302090105","name":"湖北省十堰市公安局茅箭区分局人民路派出所百二河村警务室"},
  {"id":"420302090106","name":"湖北省十堰市公安局茅箭区分局人民路派出所十堰桥村警务室"},
  {"id":"420302090107","name":"湖北省十堰市公安局茅箭区分局人民路派出所富康社区警务室"},
  {"id":"420302090108","name":"湖北省十堰市公安局茅箭区分局人民路派出所三堰社区警务室"},
  {"id":"420302090109","name":"湖北省十堰市公安局茅箭区分局人民路派出所二堰桥社区警务室"},
  {"id":"420302090110","name":"湖北省十堰市公安局茅箭区分局人民路派出所郑家沟社区警务室"},
  {"id":"420302090111","name":"湖北省十堰市公安局茅箭区分局人民路派出所擂鼓台社区警务室"},
  {"id":"420302090112","name":"湖北省十堰市公安局茅箭区分局人民路派出所高校园社区警务室"},
  {"id":"420302090113","name":"湖北省十堰市公安局茅箭区分局人民路派出所姜湾村警务室"},
  {"id":"420302100000","name":"大川派出所"},
  {"id":"420302100101","name":"湖北省十堰市公安局茅箭区分局武当路派出所顾家岗警务室"},
  {"id":"420302100102","name":"湖北省十堰市公安局茅箭区分局武当路派出所顾家村警务室"},
  {"id":"420302100103","name":"湖北省十堰市公安局茅箭区分局武当路派出所铁三处警务室"},
  {"id":"420302100104","name":"湖北省十堰市公安局茅箭区分局武当路派出所堰口桥村警务室"},
  {"id":"420302110000","name":"交通治安派出所"},
  {"id":"420302110101","name":"湖北省十堰市公安局茅箭区分局大川派出所小川村警务室"},
  {"id":"420302110102","name":"湖北省十堰市公安局茅箭区分局大川派出所营子村警务室"},
  {"id":"420302120000","name":"湖北省十堰市公安局茅箭区分局东城开发区派出所"},
  {"id":"420302120101","name":"湖北省十堰市公安局茅箭区分局东城开发区派出所西坪警务室"},
  {"id":"420302120102","name":"湖北省十堰市公安局茅箭区分局东城开发区派出所茅箭堂警务室"},
  {"id":"420302120103","name":"湖北省十堰市公安局茅箭区分局东城开发区派出所鸳鸯警务室"},
  {"id":"420303060000","name":"汉江路派出所"},
  {"id":"420303070000","name":"东岳路派出所"},
  {"id":"420303080000","name":"车城西路派出所"},
  {"id":"420303080101","name":"湖北省十堰市公安局张湾区分局汉江路派出所东风社区警务室"},
  {"id":"420303080102","name":"湖北省十堰市公安局张湾区分局汉江路派出所七里社区警务室"},
  {"id":"420303080103","name":"十堰市公安局张湾区分局汉江路派出所夏家店阳光栖谷社区警务室"},
  {"id":"420303080104","name":"湖北省十堰市公安局张湾区分局汉江路派出所罗家岗社区警务室"},
  {"id":"420303080105","name":"湖北省十堰市公安局张湾区分局汉江路派出所八亩地村警务室"},
  {"id":"420303080106","name":"湖北省十堰市公安局张湾区分局汉江路派出所茅坪村警务室"},
  {"id":"420303080107","name":"湖北省十堰市公安局张湾区分局汉江路派出所七里垭村警务室"},
  {"id":"420303080108","name":"湖北省十堰市公安局张湾区分局汉江路派出所六堰社区警务室"},
  {"id":"420303090000","name":"花果路派出所"},
  {"id":"420303090101","name":"湖北省十堰市公安局张湾区分局东岳路派出所人民广场社区警务室"},
  {"id":"420303090102","name":"湖北省十堰市公安局张湾区分局东岳路派出所公园社区警务室"},
  {"id":"420303090103","name":"湖北省十堰市公安局张湾区分局东岳路派出所东岳古台社区警务室"},
  {"id":"420303090104","name":"湖北省十堰市公安局张湾区分局东岳路派出所高家湾社区警务室"},
  {"id":"420303090105","name":"湖北省十堰市公安局张湾区分局东岳路派出所谢家村警务室"},
  {"id":"420303090106","name":"湖北省十堰市公安局张湾区分局东岳路派出所工艺新村社区警务室"},
  {"id":"420303090107","name":"湖北省十堰市公安局张湾区分局东岳路派出所艳湖社区警务室"},
  {"id":"420303090108","name":"湖北省十堰市公安局张湾区分局东岳路派出所镜潭社区警务室"},
  {"id":"420303090109","name":"湖北省十堰市公安局张湾区分局东岳路派出所车城西路社区警务室"},
  {"id":"420303090110","name":"湖北省十堰市公安局张湾区分局东岳路派出所康乐社区警务室"},
  {"id":"420303090111","name":"湖北省十堰市公安局张湾区分局东岳路派出所张湾社区警务室"},
  {"id":"420303100000","name":"柏林派出所"},
  {"id":"420303100101","name":"湖北省十堰市公安局张湾区分局车城西路派出所王湾社区警务室"},
  {"id":"420303100102","name":"湖北省十堰市公安局张湾区分局车城西路派出所曾家村警务室"},
  {"id":"420303100103","name":"湖北省十堰市公安局张湾区分局车城西路派出所动力新村社区警务室"},
  {"id":"420303100104","name":"湖北省十堰市公安局张湾区分局车城西路派出所界牌社区警务室"},
  {"id":"420303100105","name":"湖北省十堰市公安局张湾区分局车城西路派出所燕沟社区警务室"},
  {"id":"420303110000","name":"黄龙派出所"},
  {"id":"420303110101","name":"湖北省十堰市公安局张湾区分局花果派出所二堰铺社区警务室"},
  {"id":"420303110102","name":"湖北省十堰市公安局张湾区分局花果派出所工业新区警务室"},
  {"id":"420303110103","name":"湖北省十堰市公安局张湾区分局花果派出所西沟乡农村警务室"},
  {"id":"420303110104","name":"湖北省十堰市公安局张湾区分局花果派出所二堰村警务室"},
  {"id":"420303110105","name":"湖北省十堰市公安局张湾区分局花果派出所岔河村警务室"},
  {"id":"420303110106","name":"湖北省十堰市公安局张湾区分局花果派出所花果园社区警务室"},
  {"id":"420303110107","name":"湖北省十堰市公安局张湾区分局花果派出所花园新村社区警务室"},
  {"id":"420303120000","name":"大峡水路派出所"},
  {"id":"420303120101","name":"湖北省十堰市公安局张湾区分局柏林派出所柏林警务室"},
  {"id":"420303120102","name":"湖北省十堰市公安局张湾区分局柏林派出所西城警务室"},
  {"id":"420303130000","name":"北郊派出所"},
  {"id":"420303130101","name":"湖北省十堰市公安局张湾区分局黄龙派出所大坝社区警务室"},
  {"id":"420303130102","name":"湖北省十堰市公安局张湾区分局黄龙派出所双丰村警务室"},
  {"id":"420303130103","name":"湖北省十堰市公安局张湾区分局黄龙派出所方滩乡中心警务室"},
  {"id":"420304060000","name":"白浪路派出所"},
  {"id":"420304060100","name":"湖北省十堰市公安局十堰经济开发区分局白浪路派出所"},
  {"id":"420304060101","name":"十堰市公安局十堰经济开发区分局白浪路派出所马路社区警务室"},
  {"id":"420304060102","name":"湖北省十堰市公安局十堰经济开发区分局白浪路派出所马路村警务室"},
  {"id":"420304060103","name":"湖北省十堰市公安局十堰经济开发区分局白浪路派出所白浪村警务室"},
  {"id":"420304060104","name":"十堰市公安局十堰经济开发区分局白浪路派出所中观社区警务室"},
  {"id":"420304060105","name":"十堰市公安局十堰经济开发区分局白浪路派出所茅塔乡中心警务室"},
  {"id":"420304060106","name":"湖北省十堰市公安局十堰经济开发区分局白浪路派出所小河村警务室"},
  {"id":"420304060107","name":"湖北省十堰市公安局十堰经济开发区分局白浪路派出所方块村警务室"},
  {"id":"420304060108","name":"十堰市公安局十堰经济开发区分局白浪路派出所光明社区警务室"},
  {"id":"420304060109","name":"十堰市公安局十堰经济开发区分局白浪路派出所白浪堂社区警务室"},
  {"id":"420304060110","name":"十堰市公安局十堰经济开发区分局白浪路派出所柯家垭村警务室"},
  {"id":"420321180000","name":"城关派出所"},
  {"id":"420321180101","name":"湖北省十堰市公安局郧阳区分局城关派出所体育场社区警务室"},
  {"id":"420321180102","name":"湖北省十堰市公安局郧阳区分局城关派出所武阳岭社区警务室"},
  {"id":"420321180103","name":"湖北省十堰市公安局郧阳区分局城关派出所中岭社区警务室"},
  {"id":"420321180104","name":"湖北省十堰市公安局郧阳区分局城关派出所菜园社区警务室"},
  {"id":"420321180105","name":"湖北省十堰市公安局郧阳区分局城关派出所北门社区警务室"},
  {"id":"420321180106","name":"湖北省十堰市公安局郧阳区分局城关派出所城北社区警务室"},
  {"id":"420321180107","name":"湖北省十堰市公安局郧阳区分局城关派出所兴郧社区警务室"},
  {"id":"420321180108","name":"湖北省十堰市公安局郧阳区分局城关派出所大堰警务室"},
  {"id":"420321190000","name":"鲍峡派出所"},
  {"id":"420321190101","name":"湖北省十堰市公安局郧阳区分局鲍峡派出所东河警务室"},
  {"id":"420321200000","name":"柳陂派出所"},
  {"id":"420321200101","name":"湖北省十堰市公安局郧阳区分局柳陂派出所卧龙岗警务室"},
  {"id":"420321200102","name":"湖北省十堰市公安局郧阳区分局柳陂派出所辽瓦警务室"},
  {"id":"420321210000","name":"水上派出所"},
  {"id":"420321220000","name":"城东派出所"},
  {"id":"420321230000","name":"青曲派出所"},
  {"id":"420321240000","name":"大柳派出所"},
  {"id":"420321250000","name":"杨溪派出所"},
  {"id":"420321250101","name":"湖北省十堰市公安局郧阳区分局杨溪派出所刘湾警务室"},
  {"id":"420321260000","name":"白桑派出所"},
  {"id":"420321260101","name":"湖北省十堰市公安局郧阳区分局白桑派出所高庙警务室"},
  {"id":"420321270000","name":"安阳派出所"},
  {"id":"420321270101","name":"湖北省十堰市公安局郧阳区分局安阳派出所龙门警务室"},
  {"id":"420321280000","name":"南化派出所"},
  {"id":"420321280101","name":"湖北省十堰市公安局郧阳区分局南化派出所黄柿警务室"},
  {"id":"420321290000","name":"谭山派出所"},
  {"id":"420321300000","name":"梅铺派出所"},
  {"id":"420321310000","name":"刘洞派出所"},
  {"id":"420321310101","name":"湖北省十堰市公安局郧阳区分局刘洞派出所杨沟警务室"},
  {"id":"420321320000","name":"白浪派出所"},
  {"id":"420321330000","name":"茶店派出所"},
  {"id":"420321330101","name":"湖北省十堰市公安局郧阳区分局茶店派出所蔡家岭警务室"},
  {"id":"420321340000","name":"青山派出所"},
  {"id":"420321350000","name":"五峰派出所"},
  {"id":"420321350101","name":"湖北省十堰市公安局郧阳区分局五峰派出所安城警务室"},
  {"id":"420321360000","name":"胡家营派出所"},
  {"id":"420321370000","name":"叶大派出所"},
  {"id":"420322170000","name":"城关派出所"},
  {"id":"420322170101","name":"湖北省郧西县公安局城关派出所东方社区警务室"},
  {"id":"420322170102","name":"湖北省郧西县公安局城关派出所东营社区警务室"},
  {"id":"420322170103","name":"湖北省郧西县公安局城关派出所民联社区警务室"},
  {"id":"420322170104","name":"湖北省郧西县公安局城关派出所春桥社区警务室"},
  {"id":"420322170105","name":"湖北省郧西县公安局城关派出所校场坡社区警务室"},
  {"id":"420322170106","name":"湖北省郧西县公安局城关派出所天河坪社区警务室"},
  {"id":"420322170107","name":"湖北省郧西县公安局城关派出所佘家湾社区警务室"},
  {"id":"420322170108","name":"湖北省郧西县公安局城关派出所王家坪警务室"},
  {"id":"420322180000","name":"土门派出所"},
  {"id":"420322180101","name":"湖北省郧西县公安局土门派出所茅坪警务室"},
  {"id":"420322190000","name":"香口派出所"},
  {"id":"420322190101","name":"湖北省郧西县公安局香口派出所六斗警务室"},
  {"id":"420322200000","name":"上津派出所"},
  {"id":"420322200101","name":"湖北省郧西县公安局上津派出所槐树警务室"},
  {"id":"420322210000","name":"六郎派出所"},
  {"id":"420322210101","name":"湖北省郧西县公安局六郎派出所六朗警务室"},
  {"id":"420322220000","name":"店子派出所"},
  {"id":"420322230000","name":"关防派出所"},
  {"id":"420322240000","name":"湖北口派出所"},
  {"id":"420322250000","name":"景阳派出所"},
  {"id":"420322250101","name":"湖北省郧西县公安局景阳派出所泥沟警务室"},
  {"id":"420322260000","name":"夹河派出所"},
  {"id":"420322260101","name":"湖北省郧西县公安局夹河派出所黑虎警务室"},
  {"id":"420322270000","name":"羊尾派出所"},
  {"id":"420322280000","name":"涧池派出所"},
  {"id":"420322290000","name":"观音派出所"},
  {"id":"420322290101","name":"湖北省郧西县公安局观音派出所五顶警务室"},
  {"id":"420322300000","name":"马安派出所"},
  {"id":"420322310000","name":"河夹派出所"},
  {"id":"420322310101","name":"湖北省郧西县公安局河夹派出所童元警务室"},
  {"id":"420322320000","name":"安家派出所"},
  {"id":"420322320101","name":"湖北省郧西县公安局安家派出所三官警务室"},
  {"id":"420322330000","name":"水上派出所"},
  {"id":"420323170000","name":"城关派出所"},
  {"id":"420323170101","name":"湖北省竹山县公安局城关水陆派出所东门警务室"},
  {"id":"420323170102","name":"湖北省竹山县公安局城关水陆派出所西关警务室"},
  {"id":"420323170103","name":"湖北省竹山县公安局城关水陆派出所大街警务室"},
  {"id":"420323170104","name":"湖北省竹山县公安局城关水陆派出所北大街警务室"},
  {"id":"420323170105","name":"湖北省竹山县公安局城关水陆派出所农村警务室"},
  {"id":"420323170106","name":"湖北省竹山县公安局城关水陆派出所城西警务室"},
  {"id":"420323180000","name":"潘口派出所"},
  {"id":"420323180101","name":"湖北省竹山县公安局潘口派出所小璇警务室"},
  {"id":"420323190000","name":"文峰派出所"},
  {"id":"420323190101","name":"湖北省竹山县公安局文峰派出所太和警务室"},
  {"id":"420323200000","name":"溢水派出所"},
  {"id":"420323200101","name":"湖北省竹山县公安局溢水派出所下腰店警务室"},
  {"id":"420323220000","name":"麻家渡派出所"},
  {"id":"420323220101","name":"湖北省竹山县公安局麻家渡派出所移民新区警务室"},
  {"id":"420323230000","name":"宝丰派出所"},
  {"id":"420323230101","name":"湖北省竹山县公安局宝丰派出所施洋路警务室"},
  {"id":"420323240000","name":"擂鼓派出所"},
  {"id":"420323240101","name":"湖北省竹山县公安局擂鼓派出所护驾警务室"},
  {"id":"420323250000","name":"秦古派出所"},
  {"id":"420323250101","name":"湖北省竹山县公安局秦古派出所富康路警务区"},
  {"id":"420323250102","name":"湖北省竹山县公安局秦古派出所富康路警务室"},
  {"id":"420323260000","name":"竹坪派出所"},
  {"id":"420323260101","name":"湖北省竹山县公安局竹坪派出所周家湾警务室"},
  {"id":"420323270000","name":"得胜派出所"},
  {"id":"420323270101","name":"湖北省竹山县公安局得胜派出所大桥警务室"},
  {"id":"420323280000","name":"大庙派出所"},
  {"id":"420323280101","name":"湖北省竹山县公安局大庙派出所大庙警务室"},
  {"id":"420323290000","name":"双台派出所"},
  {"id":"420323290101","name":"湖北省竹山县公安局双台派出所双台警务室"},
  {"id":"420323300000","name":"楼台派出所"},
  {"id":"420323300101","name":"湖北省竹山县公安局楼台派出所楼台警务室"},
  {"id":"420323310000","name":"上庸派出所"},
  {"id":"420323310101","name":"湖北省竹山县公安局上庸派出所南坝警务室"},
  {"id":"420323320000","name":"深河派出所"},
  {"id":"420323320101","name":"湖北省竹山县公安局深河派出所茅坝警务室"},
  {"id":"420323330000","name":"官渡派出所"},
  {"id":"420323330101","name":"湖北省竹山县公安局官渡派出所官渡街警务室"},
  {"id":"420323340000","name":"柳林派出所"},
  {"id":"420323340101","name":"湖北省竹山县公安局柳林派出所洪坪警务室"},
  {"id":"420324210000","name":"城关派出所"},
  {"id":"420324210101","name":"湖北省竹溪县公安局城关派出所鼓楼社区警务室"},
  {"id":"420324210102","name":"湖北省竹溪县公安局城关派出所西关街社区警务室"},
  {"id":"420324210103","name":"湖北省竹溪县公安局城关派出所东郊社区警务室"},
  {"id":"420324210104","name":"湖北省竹溪县公安局城关派出所幸福社区警务室"},
  {"id":"420324210105","name":"湖北省竹溪县公安局城关派出所工业园区警务室"},
  {"id":"420324220000","name":"蒋家堰派出所"},
  {"id":"420324230000","name":"中峰派出所"},
  {"id":"420324240000","name":"龙坝派出所"},
  {"id":"420324250000","name":"水坪派出所"},
  {"id":"420324250101","name":"湖北省竹溪县公安局水坪派出所洛河警务室"},
  {"id":"420324260000","name":"县河派出所"},
  {"id":"420324270000","name":"新洲派出所"},
  {"id":"420324270101","name":"湖北省竹溪县公安局新洲派出所马家河警务室"},
  {"id":"420324280000","name":"兵营派出所"},
  {"id":"420324290000","name":"鄂坪派出所"},
  {"id":"420324300000","name":"汇湾派出所"},
  {"id":"420324310000","name":"泉溪派出所"},
  {"id":"420324320000","name":"丰溪派出所"},
  {"id":"420324330000","name":"天宝派出所"},
  {"id":"420324330101","name":"湖北省竹溪县公安局天宝派出所龙滩警务室"},
  {"id":"420324340000","name":"桃源派出所"},
  {"id":"420324340101","name":"湖北省竹溪县公安局桃源派出所瓦沧警务室"},
  {"id":"420324350000","name":"向坝派出所"},
  {"id":"420324350101","name":"湖北省竹溪县公安局向坝派出所双桥警务室"},
  {"id":"420325170000","name":"城关派出所"},
  {"id":"420325170101","name":"湖北省房县公安局城关派出所东关社区警务室"},
  {"id":"420325170102","name":"湖北省房县公安局城关派出所下西关社区警务室"},
  {"id":"420325170103","name":"湖北省房县公安局城关派出所中西关社区警务室"},
  {"id":"420325170104","name":"湖北省房县公安局城关派出所小西关社区警务室"},
  {"id":"420325170105","name":"湖北省房县公安局城关派出所北关社区警务室"},
  {"id":"420325170106","name":"湖北省房县公安局城关派出所桃园社区警务室"},
  {"id":"420325170107","name":"湖北省房县公安局城关派出所白路警务室"},
  {"id":"420325170108","name":"湖北省房县公安局城关派出所老城社区警务室"},
  {"id":"420325170109","name":"湖北省房县公安局城关派出所联观社区警务室"},
  {"id":"420325170110","name":"湖北省房县公安局城关派出所花宝社区警务室"},
  {"id":"420325170111","name":"湖北省房县公安局城关派出所泉水社区警务室"},
  {"id":"420325180000","name":"红塔派出所"},
  {"id":"420325180101","name":"湖北省房县公安局红塔派出所高枧警务室"},
  {"id":"420325190000","name":"军店派出所"},
  {"id":"420325190101","name":"湖北省房县公安局军店派出所下茅坪警务室"},
  {"id":"420325200000","name":"化龙派出所"},
  {"id":"420325200101","name":"湖北省房县公安局化龙派出所集镇警务室"},
  {"id":"420325210000","name":"窑淮派出所"},
  {"id":"420325210101","name":"湖北省房县公安局窑淮派出所铺沟警务室"},
  {"id":"420325220000","name":"门古派出所"},
  {"id":"420325220101","name":"湖北省房县公安局门古派出所秦口警务室"},
  {"id":"420325230000","name":"上龛派出所"},
  {"id":"420325230101","name":"湖北省房县公安局上龛派出所仓坪警务室"},
  {"id":"420325240000","name":"中坝派出所"},
  {"id":"420325240101","name":"湖北省房县公安局中坝派出所龙驹山警务室"},
  {"id":"420325250000","name":"九道派出所"},
  {"id":"420325250101","name":"湖北省房县公安局九道派出所八里坪警务室"},
  {"id":"420325260000","name":"桥上派出所"},
  {"id":"420325260101","name":"湖北省房县公安局野人谷派出所安阳警务室"},
  {"id":"420325270000","name":"青峰派出所"},
  {"id":"420325270101","name":"湖北省房县公安局青峰派出所中堰警务室"},
  {"id":"420325280000","name":"榔口派出所"},
  {"id":"420325280101","name":"湖北省房县公安局尹吉甫派出所榔口警务室"},
  {"id":"420325290000","name":"沙河派出所"},
  {"id":"420325290101","name":"湖北省房县公安局沙河派出所白沙河警务室"},
  {"id":"420325300000","name":"万峪派出所"},
  {"id":"420325300101","name":"湖北省房县公安局万峪派出所老人坪警务室"},
  {"id":"420325310000","name":"白窝派出所"},
  {"id":"420325310101","name":"湖北省房县公安局白鹤派出所孙家湾警务室"},
  {"id":"420325320000","name":"土城派出所"},
  {"id":"420325320101","name":"湖北省房县公安局土城派出所龙坪警务室"},
  {"id":"420325330000","name":"大木派出所"},
  {"id":"420325330101","name":"湖北省房县公安局大木派出所板桥警务室"},
  {"id":"420325340000","name":"姚坪派出所"},
  {"id":"420325340101","name":"湖北省房县公安局姚坪派出所西坡警务室"},
  {"id":"420325350000","name":"湖北省房县公安局五台派出所"},
  {"id":"420325350101","name":"湖北省房县公安局五台派出所三里坪警务室"},
  {"id":"420381190000","name":"湖北省丹江口市公安局水上第二派出所"},
  {"id":"420381200000","name":"均州路派出所"},
  {"id":"420381200101","name":"湖北省丹江口市公安局均州路派出所泰山庙警务室"},
  {"id":"420381200102","name":"湖北省丹江口市公安局均州路派出所均州警务室"},
  {"id":"420381200103","name":"湖北省丹江口市公安局均州路派出所张家营警务室"},
  {"id":"420381200104","name":"湖北省丹江口市公安局均州路派出所奥华御园警务室"},
  {"id":"420381210000","name":"大坝派出所"},
  {"id":"420381210101","name":"湖北省丹江口市公安局大坝派出所汉江社区警务室"},
  {"id":"420381210102","name":"湖北省丹江口市公安局大坝派出所跃进门社区警务室"},
  {"id":"420381210103","name":"湖北省丹江口市公安局大坝派出所集团新村社区警务室"},
  {"id":"420381210104","name":"湖北省丹江口市公安局大坝派出所宾江社区警务室"},
  {"id":"420381220000","name":"新港派出所"},
  {"id":"420381220101","name":"湖北省丹江口市公安局新港派出所陈家港村警务室"},
  {"id":"420381230000","name":"丹赵路派出所"},
  {"id":"420381230101","name":"湖北省丹江口市公安局丹赵路派出所漫水桥警务室"},
  {"id":"420381230102","name":"湖北省丹江口市公安局丹赵路派出所茅腊坪警务室"},
  {"id":"420381240000","name":"三官殿派出所"},
  {"id":"420381240101","name":"湖北省丹江口市公安局三官殿派出所安乐河警务室"},
  {"id":"420381250000","name":"水上派出所"},
  {"id":"420381260000","name":"土关垭派出所"},
  {"id":"420381260101","name":"湖北省丹江口市公安局土关垭派出所银洞山警务室"},
  {"id":"420381270000","name":"浪河派出所"},
  {"id":"420381270101","name":"湖北省丹江口市公安局浪河派出所白杨坪警务室"},
  {"id":"420381280000","name":"丁家营派出所"},
  {"id":"420381280101","name":"湖北省丹江口市公安局丁家营派出所铜架山警务室"},
  {"id":"420381290000","name":"老营派出所"},
  {"id":"420381300000","name":"武当山派出所"},
  {"id":"420381310000","name":"六里坪派出所"},
  {"id":"420381310101","name":"湖北省丹江口市公安局六里坪派出所岗河警务室"},
  {"id":"420381320000","name":"牛河派出所"},
  {"id":"420381320101","name":"湖北省丹江口市公安局牛河派出所五谷庙村警务室"},
  {"id":"420381330000","name":"土台派出所"},
  {"id":"420381330101","name":"湖北省丹江口市公安局土台派出所龙山沟警务室"},
  {"id":"420381340000","name":"盐池河派出所"},
  {"id":"420381340101","name":"湖北省丹江口市公安局盐池河派出所盐池湾警务室"},
  {"id":"420381350000","name":"官山派出所"},
  {"id":"420381350101","name":"湖北省丹江口市公安局官山派出所上三河警务室"},
  {"id":"420381360000","name":"肖川派出所"},
  {"id":"420381360101","name":"湖北省丹江口市公安局均县派出所黄峰警务室"},
  {"id":"420381370000","name":"凉水河派出所"},
  {"id":"420381370101","name":"湖北省丹江口市公安局凉水河派出所柳河口警务室"},
  {"id":"420381380000","name":"罗店派出所"},
  {"id":"420381380101","name":"湖北省丹江口市公安局石鼓派出所玉皇顶警务室"},
  {"id":"420381390000","name":"蒿坪派出所"},
  {"id":"420381390101","name":"湖北省丹江口市公安局蒿坪派出所观音庙警务室"},
  {"id":"420381400000","name":"习家店派出所"},
  {"id":"420381400101","name":"湖北省丹江口市公安局习家店派出所大沟警务室"},
  {"id":"420397060000","name":"武当山派出所"},
  {"id":"420397070000","name":"湖北省武当山旅游经济特区公安局老营派出所"},
  {"id":"420397070101","name":"湖北省武当山旅游经济特区公安局老营派出所老营社区中心警务室"},
  {"id":"420397070102","name":"湖北省武当山旅游经济特区公安局老营派出所元和观警务室"},
  {"id":"420397120000","name":"湖北省武当山旅游经济特区公安局太极湖水陆派出所"},
  {"id":"420397120101","name":"湖北省武当山旅游经济特区公安局太极湖水陆派出所新区警务室"},
  {"id":"420397120102","name":"湖北省武当山旅游经济特区公安局太极湖水陆派出所蓝湾警务室"},
  {"id":"420397120103","name":"湖北省武当山旅游经济特区公安局太极湖水陆派出所生态区警务室"},
  {"id":"420399150000","name":"湖北省十堰市公安局东岳分局东安派出所"},
  {"id":"420399150101","name":"湖北省十堰市公安局东岳分局东安派出所二机电社区警务室"},
  {"id":"420399150102","name":"湖北省十堰市公安局东岳分局东安派出所铸造社区警务室"},
  {"id":"420399160000","name":"湖北省十堰市公安局东岳分局东区派出所"},
  {"id":"420399160101","name":"湖北省十堰市公安局东岳分局东区派出所金桥社区警务室"},
  {"id":"420399160102","name":"湖北省十堰市公安局东岳分局东区派出所泰安社区警务室"},
  {"id":"420399170000","name":"湖北省十堰市公安局东岳分局东电派出所"},
  {"id":"420399170101","name":"湖北省十堰市公安局东岳分局东电派出所绿苑社区警务室"},
  {"id":"420399170102","name":"湖北省十堰市公安局东岳分局东电派出所旭日社区警务室"},
  {"id":"420399180000","name":"湖北省十堰市公安局东岳分局北区派出所"},
  {"id":"420399180101","name":"湖北省十堰市公安局东岳分局北区派出所海南社区警务室"},
  {"id":"420399180102","name":"湖北省十堰市公安局东岳分局北区派出所银河社区警务室"},
  {"id":"420399180103","name":"湖北省十堰市公安局东岳分局北区派出所文汇社区警务室"},
  {"id":"420399190000","name":"湖北省十堰市公安局东岳分局南区派出所"},
  {"id":"420399190101","name":"湖北省十堰市公安局东岳分局南区派出所古台社区警务室"},
  {"id":"420399190102","name":"湖北省十堰市公安局东岳分局南区派出所艳湖社区警务室"},
  {"id":"420399190103","name":"湖北省十堰市公安局东岳分局南区派出所镜谭小区警务室"},
  {"id":"420399200000","name":"湖北省十堰市公安局东岳分局中区派出所"},
  {"id":"420399200101","name":"湖北省十堰市公安局东岳分局中区派出所光明新村社区警务室"},
  {"id":"420399200102","name":"湖北省十堰市公安局东岳分局中区派出所动力社区警务室"},
  {"id":"420399200103","name":"湖北省十堰市公安局东岳分局中区派出所寺包社区警务室"},
  {"id":"420399210000","name":"湖北省十堰市公安局东岳分局西区派出所"},
  {"id":"420399210101","name":"湖北省十堰市公安局东岳分局西区派出所铸一新村社区警务室"},
  {"id":"420399210102","name":"湖北省十堰市公安局东岳分局西区派出所安沟社区警务室"},
  {"id":"420502100000","name":"云集派出所"},
  {"id":"420502200000","name":"鼓楼街派出所"},
  {"id":"420502300000","name":"学院街派出所"},
  {"id":"420502400000","name":"西陵派出所"},
  {"id":"420502500000","name":"白龙岗派出所"},
  {"id":"420502530000","name":"鼓楼派出所"},
  {"id":"420502600000","name":"峡口风景区派出所"},
  {"id":"420502700000","name":"窑湾派出所"},
  {"id":"420503100000","name":"大公桥派出所"},
  {"id":"420503200000","name":"万寿桥派出所"},
  {"id":"420503300000","name":"宝塔河派出所"},
  {"id":"420503400000","name":"向阳派出所"},
  {"id":"420503500000","name":"伍家派出所"},
  {"id":"420503530000","name":"宝塔河派出所"},
  {"id":"420503540000","name":"伍家派出所"},
  {"id":"420503550000","name":"万寿桥派出所"},
  {"id":"420503560000","name":"中南派出所"},
  {"id":"420503600000","name":"站前派出所"},
  {"id":"420504100000","name":"点军派出所"},
  {"id":"420504200000","name":"桥边派出所"},
  {"id":"420504300000","name":"土城派出所"},
  {"id":"420504400000","name":"联棚派出所"},
  {"id":"420504500000","name":"艾家派出所"},
  {"id":"420504510000","name":"点军派出所"},
  {"id":"420504520000","name":"朱市街派出所"},
  {"id":"420504530000","name":"联棚派出所"},
  {"id":"420504540000","name":"土城派出所"},
  {"id":"420504550000","name":"桥边派出所"},
  {"id":"420504560000","name":"艾家派出所"},
  {"id":"420504570000","name":"五龙派出所"},
  {"id":"420505100000","name":"古老背水陆派出所"},
  {"id":"420505200000","name":"云池派出所"},
  {"id":"420505300000","name":"虎牙派出所"},
  {"id":"420505510000","name":"古老背派出所"},
  {"id":"420505520000","name":"云池派出所"},
  {"id":"420505530000","name":"虎牙派出所"},
  {"id":"420506510000","name":"小溪塔派出所"},
  {"id":"420506520000","name":"张家场派出所"},
  {"id":"420506540000","name":"黄花派出所"},
  {"id":"420506550000","name":"分乡派出所"},
  {"id":"420506560000","name":"雾渡河派出所"},
  {"id":"420506570000","name":"樟村坪派出所"},
  {"id":"420506580000","name":"下堡坪派出所"},
  {"id":"420506590000","name":"鸦鹊岭派出所"},
  {"id":"420506600000","name":"龙泉派出所"},
  {"id":"420506610000","name":"三斗坪派出所"},
  {"id":"420506620000","name":"乐天溪派出所"},
  {"id":"420506630000","name":"太平溪派出所"},
  {"id":"420506640000","name":"邓村派出所"},
  {"id":"420520530000","name":"鼓楼派出所"},
  {"id":"420521100000","name":"小溪塔派出所"},
  {"id":"420521110000","name":"乐天溪派出所"},
  {"id":"420521120000","name":"太平溪派出所"},
  {"id":"420521130000","name":"邓村派出所"},
  {"id":"420521140000","name":"三斗坪派出所"},
  {"id":"420521200000","name":"张家场派出所"},
  {"id":"420521300000","name":"鸦鹊岭派出所"},
  {"id":"420521400000","name":"龙泉派出所"},
  {"id":"420521500000","name":"分乡派出所"},
  {"id":"420521600000","name":"黄花派出所"},
  {"id":"420521700000","name":"雾渡河派出所"},
  {"id":"420521800000","name":"樟村坪派出所"},
  {"id":"420521900000","name":"下堡坪派出所"},
  {"id":"420525100000","name":"鸣凤派出所"},
  {"id":"420525200000","name":"嫘祖派出所"},
  {"id":"420525300000","name":"花林寺派出所"},
  {"id":"420525400000","name":"河口派出所"},
  {"id":"420525500000","name":"茅坪场派出所"},
  {"id":"420525510000","name":"鸣凤派出所"},
  {"id":"420525520000","name":"洋坪派出所"},
  {"id":"420525530000","name":"旧县派出所"},
  {"id":"420525540000","name":"花林寺派出所"},
  {"id":"420525550000","name":"茅坪场派出所"},
  {"id":"420525560000","name":"嫘祖派出所"},
  {"id":"420525570000","name":"河口派出所"},
  {"id":"420525600000","name":"旧县派出所"},
  {"id":"420525700000","name":"洋坪派出所"},
  {"id":"420526100000","name":"古夫水陆派出所"},
  {"id":"420526200000","name":"昭君水陆派出所"},
  {"id":"420526300000","name":"南阳派出所"},
  {"id":"420526400000","name":"黄粮派出所"},
  {"id":"420526500000","name":"高桥派出所"},
  {"id":"420526510000","name":"昭君派出所"},
  {"id":"420526520000","name":"峡口派出所"},
  {"id":"420526530000","name":"水月寺派出所"},
  {"id":"420526540000","name":"古夫派出所"},
  {"id":"420526550000","name":"南阳派出所"},
  {"id":"420526560000","name":"榛子派出所"},
  {"id":"420526570000","name":"黄粮派出所"},
  {"id":"420526580000","name":"高桥派出所"},
  {"id":"420526590000","name":"交通派出所"},
  {"id":"420526600000","name":"水月寺派出所"},
  {"id":"420526700000","name":"峡口水陆派出所"},
  {"id":"420526800000","name":"榛子派出所"},
  {"id":"420527100000","name":"茅坪派出所"},
  {"id":"420527110000","name":"两河口派出所"},
  {"id":"420527120000","name":"磨坪派出所"},
  {"id":"420527130000","name":"郭家坝派出所"},
  {"id":"420527200000","name":"屈原派出所"},
  {"id":"420527300000","name":"归州派出所"},
  {"id":"420527400000","name":"水田坝派出所"},
  {"id":"420527500000","name":"泄滩派出所"},
  {"id":"420527510000","name":"茅坪派出所"},
  {"id":"420527520000","name":"屈原派出所"},
  {"id":"420527530000","name":"归洲派出所"},
  {"id":"420527540000","name":"水田坝派出所"},
  {"id":"420527550000","name":"泄滩派出所"},
  {"id":"420527560000","name":"沙镇溪派出所"},
  {"id":"420527570000","name":"两河口派出所"},
  {"id":"420527580000","name":"梅家河派出所"},
  {"id":"420527590000","name":"磨坪派出所"},
  {"id":"420527600000","name":"郭家坝派出所"},
  {"id":"420527610000","name":"周坪派出所"},
  {"id":"420527620000","name":"杨林桥派出所"},
  {"id":"420527630000","name":"水上派出所"},
  {"id":"420527700000","name":"梅家河派出所"},
  {"id":"420527800000","name":"杨林桥派出所"},
  {"id":"420527900000","name":"九畹溪派出所"},
  {"id":"420528100000","name":"龙舟坪镇派出所"},
  {"id":"420528110000","name":"鸭子口派出所"},
  {"id":"420528120000","name":"火烧坪派出所"},
  {"id":"420528200000","name":"高家堰派出所"},
  {"id":"420528300000","name":"贺家坪派出所"},
  {"id":"420528400000","name":"榔坪派出所"},
  {"id":"420528500000","name":"渔峡口派出所"},
  {"id":"420528510000","name":"隔河岩水陆派出所"},
  {"id":"420528520000","name":"榔坪派出所"},
  {"id":"420528530000","name":"贺家坪派出所"},
  {"id":"420528540000","name":"高家堰派出所"},
  {"id":"420528550000","name":"磨市派出所"},
  {"id":"420528560000","name":"大堰派出所"},
  {"id":"420528570000","name":"都正湾派出所"},
  {"id":"420528580000","name":"资丘派出所"},
  {"id":"420528590000","name":"火烧坪派出所"},
  {"id":"420528600000","name":"鸭子口派出所"},
  {"id":"420528610000","name":"龙舟坪派出所"},
  {"id":"420528620000","name":"渔峡口派出所"},
  {"id":"420528700000","name":"磨市派出所"},
  {"id":"420528800000","name":"都镇湾派出所"},
  {"id":"420528900000","name":"大堰派出所"},
  {"id":"420529100000","name":"五峰镇派出所"},
  {"id":"420529200000","name":"渔洋关派出所"},
  {"id":"420529300000","name":"采花派出所"},
  {"id":"420529400000","name":"长乐坪派出所"},
  {"id":"420529500000","name":"仁和坪派出所"},
  {"id":"420529510000","name":"五峰镇派出所"},
  {"id":"420529520000","name":"渔洋关派出所"},
  {"id":"420529530000","name":"仁和坪派出所"},
  {"id":"420529540000","name":"湾潭派出所"},
  {"id":"420529550000","name":"长乐坪派出所"},
  {"id":"420529560000","name":"采花派出所"},
  {"id":"420529570000","name":"付家堰派出所"},
  {"id":"420529580000","name":"牛庄派出所"},
  {"id":"420529600000","name":"傅家堰派出所"},
  {"id":"420529700000","name":"牛庄派出所"},
  {"id":"420529800000","name":"湾潭派出所"},
  {"id":"420581100000","name":"陆城派出所"},
  {"id":"420581110000","name":"松宜矿区派出所"},
  {"id":"420581120000","name":"松木坪派出所"},
  {"id":"420581200000","name":"枝城派出所"},
  {"id":"420581300000","name":"红花套派出所"},
  {"id":"420581400000","name":"高坝洲派出所"},
  {"id":"420581500000","name":"姚家店派出所"},
  {"id":"420581510000","name":"陆城派出所"},
  {"id":"420581520000","name":"枝城派出所"},
  {"id":"420581530000","name":"红花套派出所"},
  {"id":"420581540000","name":"姚家店派出所"},
  {"id":"420581550000","name":"高坝州派出所"},
  {"id":"420581560000","name":"五眼泉派出所"},
  {"id":"420581570000","name":"王家畈派出所"},
  {"id":"420581580000","name":"松木坪派出所"},
  {"id":"420581590000","name":"聂家河派出所"},
  {"id":"420581600000","name":"潘家湾派出所"},
  {"id":"420581610000","name":"公交水上派出所"},
  {"id":"420581620000","name":"高坝州电厂派出所"},
  {"id":"420581630000","name":"车湾派出所"},
  {"id":"420581640000","name":"宋山派出所"},
  {"id":"420581700000","name":"王家畈派出所"},
  {"id":"420581800000","name":"聂家河派出所"},
  {"id":"420581900000","name":"潘家湾派出所"},
  {"id":"420582100000","name":"当阳市玉阳派出所 "},
  {"id":"420582110000","name":"草埠湖派出所 "},
  {"id":"420582200000","name":"玉泉派出所 "},
  {"id":"420582300000","name":"坝陵派出所 "},
  {"id":"420582400000","name":"河溶派出所 "},
  {"id":"420582500000","name":"育溪派出所 "},
  {"id":"420582510000","name":"草埠湖派出所"},
  {"id":"420582520000","name":"河溶派出所"},
  {"id":"420582530000","name":"育溪派出所"},
  {"id":"420582540000","name":"庙前派出所"},
  {"id":"420582550000","name":"王店派出所"},
  {"id":"420582560000","name":"半月派出所"},
  {"id":"420582570000","name":"玉阳派出所"},
  {"id":"420582580000","name":"玉泉派出所"},
  {"id":"420582590000","name":"坝陵派出所"},
  {"id":"420582600000","name":"机场派出所"},
  {"id":"420582610000","name":"两河派出所"},
  {"id":"420582700000","name":"王店派出所 "},
  {"id":"420582800000","name":"半月派出所 "},
  {"id":"420582900000","name":"庙前派出所 "},
  {"id":"420583100000","name":"马家店派出所"},
  {"id":"420583200000","name":"七星台派出所"},
  {"id":"420583300000","name":"百里洲派出所"},
  {"id":"420583400000","name":"仙女派出所"},
  {"id":"420583500000","name":"问安派出所"},
  {"id":"420583510000","name":"马家店水陆派出所"},
  {"id":"420583520000","name":"董市水陆派出所"},
  {"id":"420583530000","name":"顾家店水陆派出所"},
  {"id":"420583540000","name":"白洋水陆派出所"},
  {"id":"420583550000","name":"安福寺派出所"},
  {"id":"420583560000","name":"仙女派出所"},
  {"id":"420583570000","name":"问安派出所"},
  {"id":"420583580000","name":"七星台水陆派出所"},
  {"id":"420583590000","name":"百里洲水陆派出所"},
  {"id":"420583600000","name":"安福寺派出所"},
  {"id":"420583700000","name":"董市派出所"},
  {"id":"420583800000","name":"顾家店派出所"},
  {"id":"420591100000","name":"白洋工业园派出所"},
  {"id":"420591200000","name":"生物产业园派出所"},
  {"id":"420591300000","name":"东山派出所"},
  {"id":"420591400000","name":"南燕派出所"},
  {"id":"420592100000","name":"中堡岛派出所"},
  {"id":"420592200000","name":"八河口派出所"},
  {"id":"420593100000","name":"樵湖派出所"},
  {"id":"420593200000","name":"肖家岗派出所"},
  {"id":"420593300000","name":"夜明珠派出所"},
  {"id":"420593400000","name":"镇镜山派出所"},
  {"id":"420593510000","name":"平湖樵湖派出所"},
  {"id":"420593520000","name":"平湖肖家岗派出所"},
  {"id":"420593530000","name":"平湖镇境山派出所"},
  {"id":"420593540000","name":"平湖夜明珠派出所"},
  {"id":"420594100000","name":"葛洲坝派出所"},
  {"id":"420594510000","name":"水陆公交水上派出所"},
  {"id":"420595100000","name":"水上派出所"},
  {"id":"420597510000","name":"葛洲坝西坝派出所"},
  {"id":"420597520000","name":"葛洲坝葛洲坝派出所"},
  {"id":"420598510000","name":"东山分局东山派出所"},
  {"id":"420598520000","name":"东山分局南燕派出所"},
  {"id":"420599510000","name":"八河口派出所"},
  {"id":"420599520000","name":"中堡岛派出所"},
  {"id":"420602130000","name":"昭明派出所"},
  {"id":"420602140000","name":"王府派出所"},
  {"id":"420602150000","name":"檀溪派出所"},
  {"id":"420602160000","name":"庞公派出所"},
  {"id":"420602170000","name":"隆中派出所"},
  {"id":"420602180000","name":"余家湖派出所"},
  {"id":"420602190000","name":"尹集派出所"},
  {"id":"420602200000","name":"卧龙派出所"},
  {"id":"420602210000","name":"欧庙派出所"},
  {"id":"420602220000","name":"顺安山派出所"},
  {"id":"420602230000","name":"周家冲派出所"},
  {"id":"420602240000","name":"虎头山派出所"},
  {"id":"420602250000","name":"贾洲派出所"},
  {"id":"420606130000","name":"中原派出所"},
  {"id":"420606140000","name":"屏襄门派出所"},
  {"id":"420606150000","name":"定中门派出所"},
  {"id":"420606160000","name":"清河口派出所"},
  {"id":"420606170000","name":"米公派出所"},
  {"id":"420606180000","name":"汉江派出所"},
  {"id":"420606190000","name":"王寨派出所"},
  {"id":"420606200000","name":"柿铺派出所"},
  {"id":"420606210000","name":"水上派出所"},
  {"id":"420606220000","name":"牛首派出所"},
  {"id":"420606230000","name":"太平派出所"},
  {"id":"420606240000","name":"人民路派出所"},
  {"id":"420606250000","name":"陈家湖派出所"},
  {"id":"420607200000","name":"张湾水陆派出所"},
  {"id":"420607210000","name":"肖湾派出所"},
  {"id":"420607220000","name":"双沟派出所"},
  {"id":"420607230000","name":"张家集派出所"},
  {"id":"420607240000","name":"东津派出所"},
  {"id":"420607250000","name":"黄龙派出所"},
  {"id":"420607260000","name":"峪山派出所"},
  {"id":"420607270000","name":"程河派出所"},
  {"id":"420607280000","name":"朱集派出所"},
  {"id":"420607290000","name":"黄集派出所"},
  {"id":"420607300000","name":"伙牌派出所"},
  {"id":"420607310000","name":"古驿派出所"},
  {"id":"420607320000","name":"龙王派出所"},
  {"id":"420607330000","name":"石桥派出所"},
  {"id":"420607350000","name":"魏庄派出所"},
  {"id":"420624150000","name":"城关派出所"},
  {"id":"420624160000","name":"武镇派出所"},
  {"id":"420624170000","name":"九集派出所"},
  {"id":"420624180000","name":"清河派出所"},
  {"id":"420624190000","name":"李庙派出所"},
  {"id":"420624200000","name":"长坪派出所"},
  {"id":"420624210000","name":"薛坪派出所"},
  {"id":"420624220000","name":"板桥派出所"},
  {"id":"420624230000","name":"巡检派出所"},
  {"id":"420624240000","name":"东巩派出所"},
  {"id":"420624250000","name":"肖堰派出所"},
  {"id":"420625120000","name":"城关派出所"},
  {"id":"420625130000","name":"石花派出所"},
  {"id":"420625140000","name":"冷集派出所"},
  {"id":"420625150000","name":"五山派出所"},
  {"id":"420625160000","name":"紫金派出所"},
  {"id":"420625170000","name":"赵湾派出所"},
  {"id":"420625180000","name":"盛康派出所"},
  {"id":"420625190000","name":"庙滩派出所"},
  {"id":"420625200000","name":"茨河派出所"},
  {"id":"420625210000","name":"南河派出所"},
  {"id":"420626160000","name":"城关派出所"},
  {"id":"420626170000","name":"黄堡派出所"},
  {"id":"420626180000","name":"后坪派出所"},
  {"id":"420626190000","name":"龙坪派出所"},
  {"id":"420626200000","name":"两峪派出所"},
  {"id":"420626210000","name":"店垭派出所"},
  {"id":"420626220000","name":"马良派出所"},
  {"id":"420626230000","name":"歇马派出所"},
  {"id":"420626240000","name":"马桥派出所"},
  {"id":"420626250000","name":"寺坪派出所"},
  {"id":"420626260000","name":"过渡湾派出所"},
  {"id":"420682190000","name":"和平路派出所"},
  {"id":"420682200000","name":"北京路派出所"},
  {"id":"420682210000","name":"赞阳派出所"},
  {"id":"420682220000","name":"水上派出所"},
  {"id":"420682230000","name":"李楼派出所"},
  {"id":"420682240000","name":"洪山咀派出所"},
  {"id":"420682250000","name":"仙人渡派出所"},
  {"id":"420682260000","name":"张集派出所"},
  {"id":"420682270000","name":"孟楼派出所"},
  {"id":"420682280000","name":"竹林桥派出所"},
  {"id":"420682290000","name":"薛集派出所"},
  {"id":"420682300000","name":"袁冲派出所"},
  {"id":"420683150000","name":"南城派出所"},
  {"id":"420683160000","name":"北城派出所"},
  {"id":"420683170000","name":"西城派出所"},
  {"id":"420683180000","name":"环城派出所"},
  {"id":"420683190000","name":"鹿头派出所"},
  {"id":"420683200000","name":"新市派出所"},
  {"id":"420683210000","name":"太平派出所"},
  {"id":"420683220000","name":"杨当派出所"},
  {"id":"420683230000","name":"七方派出所"},
  {"id":"420683240000","name":"琚湾派出所"},
  {"id":"420683250000","name":"熊集派出所"},
  {"id":"420683260000","name":"吴店派出所"},
  {"id":"420683270000","name":"平林派出所"},
  {"id":"420683280000","name":"王城派出所"},
  {"id":"420683290000","name":"兴隆派出所"},
  {"id":"420683300000","name":"刘升派出所"},
  {"id":"420684150000","name":"鄢城派出所"},
  {"id":"420684160000","name":"小河派出所"},
  {"id":"420684170000","name":"刘猴派出所"},
  {"id":"420684180000","name":"雷河派出所"},
  {"id":"420684190000","name":"上大堰派出所"},
  {"id":"420684200000","name":"孔湾派出所"},
  {"id":"420684210000","name":"郑集派出所"},
  {"id":"420684220000","name":"南营派出所"},
  {"id":"420684230000","name":"王集派出所"},
  {"id":"420684240000","name":"板桥店派出所"},
  {"id":"420684250000","name":"流水派出所"},
  {"id":"420684260000","name":"东方派出所"},
  {"id":"420697090000","name":"紫贞派出所"},
  {"id":"420697100000","name":"七里河派出所"},
  {"id":"420697110000","name":"团山派出所"},
  {"id":"420697150000","name":"飞机场派出所"},
  {"id":"420698090000","name":"车城派出所"},
  {"id":"420698100000","name":"米庄派出所"},
  {"id":"420699080000","name":"富康路派出所"},
  {"id":"420702080000","name":"太和派出所"},
  {"id":"420702090000","name":"沼山派出所"},
  {"id":"420702110000","name":"东沟派出所"},
  {"id":"420702120000","name":"涂镇派出所"},
  {"id":"420702130000","name":"梁子水陆派出所"},
  {"id":"420702140000","name":"梧桐湖派出所"},
  {"id":"420702160000","name":"水上派出所"},
  {"id":"420703090000","name":"华容派出所"},
  {"id":"420703100000","name":"庙岭派出所"},
  {"id":"420703110000","name":"临江派出所"},
  {"id":"420703120000","name":"段店派出所"},
  {"id":"420703130000","name":"蒲团派出所"},
  {"id":"420704090000","name":"古楼派出所"},
  {"id":"420704100000","name":"南浦派出所"},
  {"id":"420704110000","name":"凤凰派出所"},
  {"id":"420704120000","name":"西山派出所"},
  {"id":"420704130000","name":"汀祖派出所"},
  {"id":"420704140000","name":"泽林派出所"},
  {"id":"420704150000","name":"杨叶派出所"},
  {"id":"420704160000","name":"沿江派出所"},
  {"id":"420704170000","name":"西山公园派出所"},
  {"id":"420704180000","name":"凡口派出所"},
  {"id":"420704190000","name":"杜山派出所"},
  {"id":"420704200000","name":"碧石派出所"},
  {"id":"420704210000","name":"花湖派出所"},
  {"id":"420704220000","name":"燕矶派出所"},
  {"id":"420704230000","name":"沙窝派出所"},
  {"id":"420704240000","name":"新庙派出所"},
  {"id":"420704250000","name":"程潮派出所"},
  {"id":"420704330000","name":"长农派出所"},
  {"id":"420798080000","name":"官柳派出所"},
  {"id":"420798090000","name":"落驾坪派出所"},
  {"id":"420798110000","name":"樊口派出所"},
  {"id":"420799070000","name":"葛店派出所"},
  {"id":"420799080000","name":"黄矶派出所"},
  {"id":"420799090000","name":"岱庙派出所"},
  {"id":"420802120000","name":"龙泉派出所"},
  {"id":"420802130000","name":"泉口派出所"},
  {"id":"420802140000","name":"牌楼派出所"},
  {"id":"420802150000","name":"漳河水陆派出所"},
  {"id":"420802160000","name":"马河派出所"},
  {"id":"420802170000","name":"栗溪派出所"},
  {"id":"420802180000","name":"仙居派出所"},
  {"id":"420802190000","name":"石桥驿派出所"},
  {"id":"420802200000","name":"子陵派出所"},
  {"id":"420802210000","name":"海慧派出所"},
  {"id":"420802220000","name":"荆泉派出所"},
  {"id":"420802230000","name":"青龙观派出所"},
  {"id":"420802240000","name":"漳河派出所"},
  {"id":"420804120000","name":"白庙派出所"},
  {"id":"420804130000","name":"白石坡派出所"},
  {"id":"420804140000","name":"麻城派出所"},
  {"id":"420804150000","name":"团林派出所"},
  {"id":"420804160000","name":"宏城派出所"},
  {"id":"420821220000","name":"新市派出所"},
  {"id":"420821230000","name":"八里途派出所"},
  {"id":"420821240000","name":"永兴派出所"},
  {"id":"420821250000","name":"曹武派出所"},
  {"id":"420821260000","name":"宋河派出所"},
  {"id":"420821270000","name":"罗店派出所"},
  {"id":"420821290000","name":"坪坝派出所"},
  {"id":"420821300000","name":"三阳派出所"},
  {"id":"420821310000","name":"绿林派出所"},
  {"id":"420821320000","name":"杨集派出所"},
  {"id":"420821330000","name":"孙桥派出所"},
  {"id":"420821340000","name":"石龙派出所"},
  {"id":"420821350000","name":"永隆派出所"},
  {"id":"420821370000","name":"雁门口派出所"},
  {"id":"420821380000","name":"钱场派出所"},
  {"id":"420822200000","name":"沙洋水陆派出所"},
  {"id":"420822210000","name":"李市派出所"},
  {"id":"420822220000","name":"官垱派出所"},
  {"id":"420822230000","name":"毛李水陆派出所"},
  {"id":"420822240000","name":"后港水陆派出所"},
  {"id":"420822250000","name":"拾回桥派出所"},
  {"id":"420822260000","name":"十里铺派出所"},
  {"id":"420822270000","name":"纪山派出所"},
  {"id":"420822280000","name":"五里铺派出所"},
  {"id":"420822300000","name":"曾集派出所"},
  {"id":"420822320000","name":"沈集派出所"},
  {"id":"420822330000","name":"高阳派出所"},
  {"id":"420822340000","name":"马良水陆派出所"},
  {"id":"420822350000","name":"洪岭派出所"},
  {"id":"420881240000","name":"洋梓派出所"},
  {"id":"420881260000","name":"张集派出所"},
  {"id":"420881270000","name":"丰乐派出所"},
  {"id":"420881300000","name":"胡集派出所"},
  {"id":"420881310000","name":"双河派出所"},
  {"id":"420881320000","name":"磷矿派出所"},
  {"id":"420881330000","name":"文集派出所"},
  {"id":"420881340000","name":"冷水派出所"},
  {"id":"420881360000","name":"长寿派出所"},
  {"id":"420881370000","name":"石牌派出所"},
  {"id":"420881380000","name":"旧口派出所"},
  {"id":"420881400000","name":"柴湖派出所"},
  {"id":"420881410000","name":"长滩派出所"},
  {"id":"420881420000","name":"东桥派出所"},
  {"id":"420881430000","name":"客店派出所"},
  {"id":"420881440000","name":"九里派出所"},
  {"id":"420881450000","name":"皇庄水陆派出所"},
  {"id":"420881460000","name":"郢中派出所"},
  {"id":"420881470000","name":"机场派出所"},
  {"id":"420881480000","name":"显陵派出所"},
  {"id":"420881490000","name":"官庄湖派出所"},
  {"id":"420881520000","name":"莫愁湖派出所"},
  {"id":"420896010000","name":"牛奶山派出所"},
  {"id":"420896020000","name":"荷花垸派出所"},
  {"id":"420896030000","name":"刘家巷派出所"},
  {"id":"420896040000","name":"范家台派出所"},
  {"id":"420896050000","name":"七里湖派出所"},
  {"id":"420896060000","name":"七宝山派出所"},
  {"id":"420896070000","name":"杨家集派出所"},
  {"id":"420896080000","name":"广华寺派出所"},
  {"id":"420896090000","name":"漳湖垸派出所"},
  {"id":"420896110000","name":"黄土坡派出所"},
  {"id":"420896120000","name":"苗子湖派出所"},
  {"id":"420896130000","name":"熊望台派出所"},
  {"id":"420896140000","name":"马良派出所"},
  {"id":"420897090000","name":"刘冲派出所"},
  {"id":"420897100000","name":"王集派出所"},
  {"id":"420897110000","name":"西区派出所"},
  {"id":"420897120000","name":"东区派出所"},
  {"id":"420898120000","name":"屈岭派出所"},
  {"id":"420898130000","name":"下洋镇派出所"},
  {"id":"420898140000","name":"长滩埠派出所"},
  {"id":"420899100000","name":"油城派出所"},
  {"id":"420899110000","name":"黑风口派出所"},
  {"id":"420901008100","name":"城东派出所"},
  {"id":"420901008200","name":"航空路派出所"},
  {"id":"420902150000","name":"书院派出所"},
  {"id":"420902160000","name":"新华派出所"},
  {"id":"420902170000","name":"三里派出所"},
  {"id":"420902180000","name":"城中派出所"},
  {"id":"420902190000","name":"车站派出所"},
  {"id":"420902210000","name":"城南派出所"},
  {"id":"420902220000","name":"朱湖派出所"},
  {"id":"420902230000","name":"毛陈派出所"},
  {"id":"420902240000","name":"东山头派出所"},
  {"id":"420902260000","name":"闵集派出所"},
  {"id":"420902270000","name":"祝站派出所"},
  {"id":"420902280000","name":"三汊派出所"},
  {"id":"420902300000","name":"杨店派出所"},
  {"id":"420902310000","name":"西河派出所"},
  {"id":"420902320000","name":"新铺派出所"},
  {"id":"420902330000","name":"朋兴派出所"},
  {"id":"420902340000","name":"肖港派出所"},
  {"id":"420902350000","name":"陡岗派出所"},
  {"id":"420902360000","name":"卧龙派出所"},
  {"id":"420902550000","name":"城中派出所"},
  {"id":"420921150000","name":"花园派出所"},
  {"id":"420921160000","name":"兴城派出所"},
  {"id":"420921170000","name":"王店派出所"},
  {"id":"420921180000","name":"卫店派出所"},
  {"id":"420921190000","name":"季店派出所"},
  {"id":"420921200000","name":"花西派出所"},
  {"id":"420921210000","name":"白沙派出所"},
  {"id":"420921220000","name":"小河派出所"},
  {"id":"420921230000","name":"小悟派出所"},
  {"id":"420921240000","name":"陡山派出所"},
  {"id":"420921250000","name":"周巷派出所"},
  {"id":"420921260000","name":"邹岗派出所"},
  {"id":"420921270000","name":"丰山派出所"},
  {"id":"420922160000","name":"城关派出所"},
  {"id":"420922170000","name":"阳平派出所"},
  {"id":"420922180000","name":"芳畈派出所"},
  {"id":"420922190000","name":"新城派出所"},
  {"id":"420922200000","name":"夏店派出所"},
  {"id":"420922210000","name":"刘集派出所"},
  {"id":"420922220000","name":"河口派出所"},
  {"id":"420922230000","name":"四姑派出所"},
  {"id":"420922240000","name":"彭店派出所"},
  {"id":"420922250000","name":"吕王派出所"},
  {"id":"420922260000","name":"黄站派出所"},
  {"id":"420922270000","name":"宣化派出所"},
  {"id":"420922280000","name":"丰店派出所"},
  {"id":"420922290000","name":"高店派出所"},
  {"id":"420922300000","name":"东新派出所"},
  {"id":"420922310000","name":"大新派出所"},
  {"id":"420922320000","name":"三里派出所"},
  {"id":"420922330000","name":"黄麦岭派出所"},
  {"id":"420923180000","name":"城关派出所"},
  {"id":"420923190000","name":"城南派出所"},
  {"id":"420923200000","name":"铁西派出所"},
  {"id":"420923210000","name":"道桥派出所"},
  {"id":"420923220000","name":"下辛店派出所"},
  {"id":"420923230000","name":"隔蒲派出所"},
  {"id":"420923240000","name":"伍洛派出所"},
  {"id":"420923250000","name":"沙河派出所"},
  {"id":"420923260000","name":"吴铺派出所"},
  {"id":"420923270000","name":"曾店派出所"},
  {"id":"420923280000","name":"倒店派出所"},
  {"id":"420923290000","name":"义堂派出所"},
  {"id":"420923300000","name":"胡金店派出所"},
  {"id":"420923310000","name":"清明河派出所"},
  {"id":"420981200000","name":"有名店林场派出所"},
  {"id":"420981210000","name":"城中派出所"},
  {"id":"420981220000","name":"城北派出所"},
  {"id":"420981230000","name":"四里棚派出所"},
  {"id":"420981240000","name":"东马坊派出所"},
  {"id":"420981250000","name":"郎君派出所"},
  {"id":"420981260000","name":"长江派出所"},
  {"id":"420981270000","name":"杨河派出所"},
  {"id":"420981280000","name":"田店派出所"},
  {"id":"420981290000","name":"南垸派出所"},
  {"id":"420981300000","name":"三合派出所"},
  {"id":"420981310000","name":"黄滩派出所"},
  {"id":"420981320000","name":"天鹅派出所"},
  {"id":"420981330000","name":"义和派出所"},
  {"id":"420981340000","name":"陈河派出所"},
  {"id":"420981350000","name":"龙赛湖派出所"},
  {"id":"420981360000","name":"杨岭派出所"},
  {"id":"420981370000","name":"汤池派出所"},
  {"id":"420981390000","name":"城南派出所"},
  {"id":"420981400000","name":"新集派出所"},
  {"id":"420982200000","name":"府城派出所"},
  {"id":"420982210000","name":"东城派出所"},
  {"id":"420982220000","name":"南城派出所"},
  {"id":"420982230000","name":"伏水派出所"},
  {"id":"420982240000","name":"李店派出所"},
  {"id":"420982250000","name":"赵棚派出所"},
  {"id":"420982260000","name":"接官派出所"},
  {"id":"420982270000","name":"陈店派出所"},
  {"id":"420982280000","name":"棠棣派出所"},
  {"id":"420982290000","name":"辛榨派出所"},
  {"id":"420982310000","name":"雷公派出所"},
  {"id":"420982320000","name":"孛畈派出所"},
  {"id":"420982330000","name":"双河派出所"},
  {"id":"420982340000","name":"木梓派出所"},
  {"id":"420982350000","name":"王义贞派出所"},
  {"id":"420982360000","name":"巡店派出所"},
  {"id":"420982370000","name":"烟店派出所"},
  {"id":"420984210000","name":"城关水陆派出所"},
  {"id":"420984220000","name":"城西水陆派出所"},
  {"id":"420984230000","name":"城北水陆派出所"},
  {"id":"420984240000","name":"城东水陆派出所"},
  {"id":"420984250000","name":"小河水陆派出所"},
  {"id":"420984260000","name":"刘家隔水陆派出所"},
  {"id":"420984270000","name":"麻河水陆派出所"},
  {"id":"420984280000","name":"刁汊水陆派出所"},
  {"id":"420984290000","name":"城隍水陆派出所"},
  {"id":"420984300000","name":"华严水陆派出所"},
  {"id":"420984310000","name":"分水水陆派出所"},
  {"id":"420984320000","name":"脉旺水陆派出所"},
  {"id":"420984330000","name":"沉湖水陆派出所"},
  {"id":"420984340000","name":"福星水陆派出所"},
  {"id":"420984350000","name":"沉湖农场水陆派出所"},
  {"id":"420984360000","name":"回龙水陆派出所"},
  {"id":"420984370000","name":"田二河派出所"},
  {"id":"420984380000","name":"里潭水陆派出所"},
  {"id":"420984390000","name":"中洲水陆派出所"},
  {"id":"420984400000","name":"韩集水陆派出所"},
  {"id":"420984410000","name":"新堰水陆派出所"},
  {"id":"420984420000","name":"垌冢水陆派出所"},
  {"id":"420984430000","name":"马口水陆派出所"},
  {"id":"420984440000","name":"庙头水陆派出所"},
  {"id":"420984450000","name":"马鞍水陆派出所"},
  {"id":"420984460000","name":"南河派出所"},
  {"id":"420984470000","name":"湾潭水陆派出所"},
  {"id":"420984480000","name":"杨林沟水陆派出所"},
  {"id":"420984490000","name":"西江水陆派出所"},
  {"id":"420984500000","name":"业集林场派出所"},
  {"id":"420999050000","name":"城东派出所"},
  {"id":"420999060000","name":"航空路派出所"},
  {"id":"420999530000","name":"孝天派出所"},
  {"id":"420999540000","name":"槐荫派出所"},
  {"id":"421002510000","name":"西区派出所"},
  {"id":"421002520000","name":"解放派出所"},
  {"id":"421002530000","name":"崇文派出所"},
  {"id":"421002540000","name":"中山派出所"},
  {"id":"421002550000","name":"胜利派出所"},
  {"id":"421002560000","name":"朝阳派出所"},
  {"id":"421002570000","name":"立新派出所"},
  {"id":"421002580000","name":"水上派出所"},
  {"id":"421002590000","name":"关沮派出所"},
  {"id":"421002600000","name":"锣场派出所"},
  {"id":"421002610000","name":"观音当派出所"},
  {"id":"421002620000","name":"岑河派出所"},
  {"id":"421003510000","name":"东城派出所"},
  {"id":"421003520000","name":"西城派出所"},
  {"id":"421003530000","name":"北门派出所"},
  {"id":"421003540000","name":"御路口派出所"},
  {"id":"421003550000","name":"纪南派出所"},
  {"id":"421003560000","name":"马山派出所"},
  {"id":"421003570000","name":"川店派出所"},
  {"id":"421003580000","name":"弥市派出所"},
  {"id":"421003590000","name":"李埠派出所"},
  {"id":"421003600000","name":"八岭山派出所"},
  {"id":"421003610000","name":"太湖派出所"},
  {"id":"421003620000","name":"菱角湖派出所"},
  {"id":"421022510000","name":"斗湖堤派出所"},
  {"id":"421022520000","name":"孱陵派出所"},
  {"id":"421022530000","name":"埠河派出所"},
  {"id":"421022540000","name":"杨家厂派出所"},
  {"id":"421022550000","name":"夹竹园派出所"},
  {"id":"421022560000","name":"闸口派出所"},
  {"id":"421022570000","name":"藕池派出所"},
  {"id":"421022580000","name":"麻豪口派出所"},
  {"id":"421022590000","name":"孟家溪派出所"},
  {"id":"421022600000","name":"甘家厂派出所"},
  {"id":"421022610000","name":"章田寺派出所"},
  {"id":"421022620000","name":"南平派出所"},
  {"id":"421022630000","name":"章庄镇派出所"},
  {"id":"421022640000","name":"狮子口派出所"},
  {"id":"421022650000","name":"班竹当派出所"},
  {"id":"421022660000","name":"毛家港派出所"},
  {"id":"421022670000","name":"黄山头派出所"},
  {"id":"421023510000","name":"容城派出所"},
  {"id":"421023520000","name":"城南派出所"},
  {"id":"421023530000","name":"朱河派出所"},
  {"id":"421023540000","name":"新沟派出所"},
  {"id":"421023550000","name":"红城派出所"},
  {"id":"421023560000","name":"汴河派出所"},
  {"id":"421023570000","name":"周老嘴派出所"},
  {"id":"421023580000","name":"白螺派出所"},
  {"id":"421023590000","name":"柘木派出所"},
  {"id":"421023600000","name":"桥市派出所"},
  {"id":"421023610000","name":"棋盘派出所"},
  {"id":"421023620000","name":"尺八派出所"},
  {"id":"421023630000","name":"三洲派出所"},
  {"id":"421023640000","name":"上车湾派出所"},
  {"id":"421023650000","name":"汪桥派出所"},
  {"id":"421023660000","name":"毛市派出所"},
  {"id":"421023670000","name":"程集派出所"},
  {"id":"421023680000","name":"黄歇派出所"},
  {"id":"421023690000","name":"福田派出所"},
  {"id":"421023700000","name":"分盐派出所"},
  {"id":"421023710000","name":"龚场派出所"},
  {"id":"421023720000","name":"网市派出所"},
  {"id":"421023730000","name":"荒湖派出所"},
  {"id":"421023740000","name":"大垸派出所"},
  {"id":"421023760000","name":"水上派出所"},
  {"id":"421023770000","name":"玉沙派出所    "},
  {"id":"421024510000","name":"郝穴派出所"},
  {"id":"421024520000","name":"普济派出所"},
  {"id":"421024530000","name":"秦市派出所"},
  {"id":"421024540000","name":"沙岗派出所"},
  {"id":"421024550000","name":"白马派出所"},
  {"id":"421024560000","name":"熊河派出所"},
  {"id":"421024580000","name":"马家寨派出所"},
  {"id":"421024590000","name":"资市派出所"},
  {"id":"421024600000","name":"三湖派出所"},
  {"id":"421024610000","name":"六合垸派出所"},
  {"id":"421081510000","name":"笔架山派出所"},
  {"id":"421081520000","name":"绣林派出所"},
  {"id":"421081530000","name":"高新派出所"},
  {"id":"421081540000","name":"新厂派出所"},
  {"id":"421081550000","name":"大垸派出所"},
  {"id":"421081560000","name":"横沟派出所"},
  {"id":"421081570000","name":"调关派出所"},
  {"id":"421081580000","name":"小河口派出所"},
  {"id":"421081590000","name":"桃花山派出所"},
  {"id":"421081600000","name":"东升派出所"},
  {"id":"421081610000","name":"南口派出所"},
  {"id":"421081620000","name":"高陵派出所"},
  {"id":"421081630000","name":"团山寺派出所"},
  {"id":"421081640000","name":"高基庙派出所"},
  {"id":"421081650000","name":"久合垸派出所"},
  {"id":"421081660000","name":"天鹅洲派出所"},
  {"id":"421083510000","name":"新堤派出所"},
  {"id":"421083520000","name":"茅江派出所"},
  {"id":"421083530000","name":"峰口派出所"},
  {"id":"421083540000","name":"滨湖派出所"},
  {"id":"421083550000","name":"螺山派出所"},
  {"id":"421083560000","name":"乌林派出所"},
  {"id":"421083570000","name":"老湾派出所"},
  {"id":"421083580000","name":"龙口派出所"},
  {"id":"421083590000","name":"燕窝派出所"},
  {"id":"421083600000","name":"新滩派出所"},
  {"id":"421083610000","name":"汊河派出所"},
  {"id":"421083620000","name":"黄家口派出所"},
  {"id":"421083630000","name":"万全派出所"},
  {"id":"421083640000","name":"曹市派出所"},
  {"id":"421083650000","name":"府场派出所"},
  {"id":"421083660000","name":"沙口派出所"},
  {"id":"421083670000","name":"戴家场派出所"},
  {"id":"421083680000","name":"瞿家湾派出所"},
  {"id":"421083690000","name":"大沙派出所"},
  {"id":"421083700000","name":"大同派出所"},
  {"id":"421083710000","name":"小港派出所"},
  {"id":"421083720000","name":"沿江派出所"},
  {"id":"421087510000","name":"新江口派出所"},
  {"id":"421087520000","name":"沙道观派出所"},
  {"id":"421087530000","name":"刘家场派出所"},
  {"id":"421087540000","name":"洈水派出所"},
  {"id":"421087550000","name":"南海派出所"},
  {"id":"421087560000","name":"八宝派出所"},
  {"id":"421087570000","name":"宛市派出所"},
  {"id":"421087580000","name":"老城派出所"},
  {"id":"421087590000","name":"陈店派出所"},
  {"id":"421087600000","name":"王家桥派出所"},
  {"id":"421087620000","name":"杨林市派出所"},
  {"id":"421087630000","name":"纸厂河派出所"},
  {"id":"421087640000","name":"街河市派出所"},
  {"id":"421087650000","name":"万家派出所"},
  {"id":"421087660000","name":"卸甲坪派出所"},
  {"id":"421088510000","name":"联合乡派出所"},
  {"id":"421088520000","name":"燎原新村派出所"},
  {"id":"421088530000","name":"长港路派出所"},
  {"id":"421088540000","name":"窑湾派出所"},
  {"id":"421088550000","name":"铁路派出所"},
  {"id":"421088560000","name":"西湖派出所"},
  {"id":"421088570000","name":"滩桥派出所"},
  {"id":"421102150000","name":"胜利街派出所"},
  {"id":"421102160000","name":"东门派出所"},
  {"id":"421102170000","name":"禹王派出所"},
  {"id":"421102200000","name":"路口派出所"},
  {"id":"421102210000","name":"陶店派出所"},
  {"id":"421102220000","name":"陈策楼派出所"},
  {"id":"421102230000","name":"堵城派出所"},
  {"id":"421102240000","name":"南湖派出所"},
  {"id":"421121160000","name":"方高坪派出所"},
  {"id":"421121170000","name":"马曹庙派出所"},
  {"id":"421121180000","name":"淋山河派出所"},
  {"id":"421121190000","name":"但店派出所"},
  {"id":"421121200000","name":"杜皮派出所"},
  {"id":"421121210000","name":"贾庙派出所"},
  {"id":"421121220000","name":"回龙山派出所"},
  {"id":"421121230000","name":"团风水陆派出所"},
  {"id":"421121240000","name":"上巴河派出所"},
  {"id":"421121250000","name":"总路咀派出所"},
  {"id":"421122210000","name":"胜利街派出所"},
  {"id":"421122220000","name":"金沙派出所"},
  {"id":"421122230000","name":"城关第三派出所"},
  {"id":"421122240000","name":"杏花派出所"},
  {"id":"421122250000","name":"永河派出所"},
  {"id":"421122260000","name":"高桥派出所"},
  {"id":"421122270000","name":"觅儿派出所"},
  {"id":"421122280000","name":"八里派出所"},
  {"id":"421122290000","name":"太平派出所"},
  {"id":"421122300000","name":"二程派出所"},
  {"id":"421122310000","name":"上新集派出所"},
  {"id":"421122320000","name":"华河派出所"},
  {"id":"421122330000","name":"七里派出所"},
  {"id":"421122340000","name":"火连畈派出所"},
  {"id":"421123240000","name":"凤山派出所"},
  {"id":"421123250000","name":"骆驼坳派出所"},
  {"id":"421123260000","name":"白莲河派出所"},
  {"id":"421123280000","name":"匡河派出所"},
  {"id":"421123310000","name":"大河岸派出所"},
  {"id":"421123330000","name":"白庙河派出所"},
  {"id":"421123340000","name":"九资河派出所"},
  {"id":"421123360000","name":"河铺派出所"},
  {"id":"421123370000","name":"平湖派出所"},
  {"id":"421123380000","name":"胜利派出所"},
  {"id":"421123420000","name":"三里畈派出所"},
  {"id":"421123430000","name":"大崎派出所"},
  {"id":"421124190000","name":"南河派出所"},
  {"id":"421124200000","name":"方家咀派出所"},
  {"id":"421124230000","name":"温泉派出所"},
  {"id":"421124240000","name":"红山派出所"},
  {"id":"421124250000","name":"孔家坊派出所"},
  {"id":"421124270000","name":"金家铺派出所"},
  {"id":"421124280000","name":"石镇派出所"},
  {"id":"421124300000","name":"陶河派出所"},
  {"id":"421124310000","name":"草盘地派出所"},
  {"id":"421124330000","name":"雷家店派出所"},
  {"id":"421124340000","name":"杨柳湾派出所"},
  {"id":"421124400000","name":"陶河派出所"},
  {"id":"421124410000","name":"石头咀派出所"},
  {"id":"421125200000","name":"清泉派出所"},
  {"id":"421125210000","name":"南城派出所"},
  {"id":"421125220000","name":"汪岗派出所"},
  {"id":"421125230000","name":"团陂派出所"},
  {"id":"421125240000","name":"关口派出所"},
  {"id":"421125250000","name":"蔡河派出所"},
  {"id":"421125260000","name":"白莲派出所"},
  {"id":"421125270000","name":"洗马派出所"},
  {"id":"421125280000","name":"绿阳派出所"},
  {"id":"421125290000","name":"丁司当派出所"},
  {"id":"421125300000","name":"散花派出所"},
  {"id":"421125310000","name":"兰溪派出所"},
  {"id":"421125320000","name":"巴河派出所"},
  {"id":"421125330000","name":"竹瓦派出所"},
  {"id":"421126200000","name":"张榜派出所"},
  {"id":"421126230000","name":"蕲州水陆派出所"},
  {"id":"421126240000","name":"漕河派出所"},
  {"id":"421126250000","name":"八里湖派出所"},
  {"id":"421126260000","name":"青石派出所"},
  {"id":"421126270000","name":"向桥派出所"},
  {"id":"421126290000","name":"狮子派出所"},
  {"id":"421126310000","name":"横车派出所"},
  {"id":"421126350000","name":"刘河派出所"},
  {"id":"421126370000","name":"株林派出所"},
  {"id":"421126380000","name":"彭思派出所"},
  {"id":"421126390000","name":"赤东派出所"},
  {"id":"421126410000","name":"管窑水陆派出所"},
  {"id":"421126430000","name":"大同派出所"},
  {"id":"421126440000","name":"檀林派出所"},
  {"id":"421127140000","name":"黄梅镇派出所"},
  {"id":"421127160000","name":"下新镇水陆派出所"},
  {"id":"421127170000","name":"大河镇派出所"},
  {"id":"421127180000","name":"小池镇水陆派出所"},
  {"id":"421127190000","name":"孔垅镇派出所"},
  {"id":"421127200000","name":"停前镇派出所"},
  {"id":"421127210000","name":"五祖镇派出所"},
  {"id":"421127220000","name":"濯港镇派出所"},
  {"id":"421127230000","name":"新开镇水陆派出所"},
  {"id":"421127240000","name":"蔡山镇派出所"},
  {"id":"421127250000","name":"柳林乡派出所"},
  {"id":"421127260000","name":"杉木乡派出所"},
  {"id":"421127270000","name":"独山镇派出所"},
  {"id":"421127300000","name":"苦竹乡派出所"},
  {"id":"421127340000","name":"分路镇水陆派出所"},
  {"id":"421127360000","name":"徐港乡派出所"},
  {"id":"421127380000","name":"刘佐乡水陆派出所"},
  {"id":"421127390000","name":"九江大桥水陆派出所"},
  {"id":"421181190000","name":"鼓楼派出所"},
  {"id":"421181200000","name":"龙池桥派出所"},
  {"id":"421181210000","name":"南湖派出所"},
  {"id":"421181220000","name":"黄金桥派出所"},
  {"id":"421181230000","name":"中馆驿派出所"},
  {"id":"421181240000","name":"宋埠派出所"},
  {"id":"421181250000","name":"歧亭派出所"},
  {"id":"421181260000","name":"铁门岗派出所"},
  {"id":"421181270000","name":"夫子河派出所"},
  {"id":"421181280000","name":"白果派出所"},
  {"id":"421181290000","name":"阎家河派出所"},
  {"id":"421181300000","name":"三河口派出所"},
  {"id":"421181310000","name":"龟山派出所"},
  {"id":"421181320000","name":"盐田河派出所"},
  {"id":"421181340000","name":"木子店派出所"},
  {"id":"421181350000","name":"张家畈派出所"},
  {"id":"421181360000","name":"黄土岗派出所"},
  {"id":"421181370000","name":"福田河派出所"},
  {"id":"421181380000","name":"顺河派出所"},
  {"id":"421181390000","name":"乘马岗派出所"},
  {"id":"421182250000","name":"梅川派出所"},
  {"id":"421182300000","name":"余川派出所"},
  {"id":"421182320000","name":"花桥派出所"},
  {"id":"421182330000","name":"石佛寺派出所"},
  {"id":"421182340000","name":"大金派出所"},
  {"id":"421182350000","name":"四望派出所"},
  {"id":"421182360000","name":"大法寺派出所"},
  {"id":"421182370000","name":"田镇派出所"},
  {"id":"421182380000","name":"刊江派出所"},
  {"id":"421182400000","name":"龙潭派出所"},
  {"id":"421182410000","name":"青林派出所"},
  {"id":"421182430000","name":"龙坪派出所"},
  {"id":"421182440000","name":"万丈湖派出所"},
  {"id":"421182450000","name":"太白湖水上派出所"},
  {"id":"421198010000","name":"严家闸派出所"},
  {"id":"421198020000","name":"沙湖派出所"},
  {"id":"421198030000","name":"塞湖派出所"},
  {"id":"421199060000","name":"新港路派出所"},
  {"id":"421199070000","name":"长江水陆派出所"},
  {"id":"421199080000","name":"大桥水陆派出所"},
  {"id":"421200110000","name":"一号桥派出所"},
  {"id":"421200120000","name":"三号桥派出所"},
  {"id":"421200130000","name":"双鹤派出所"},
  {"id":"421200140000","name":"岔路口派出所"},
  {"id":"421201110000","name":"一号桥派出所"},
  {"id":"421201120000","name":"三号桥派出所"},
  {"id":"421201130000","name":"双鹤派出所"},
  {"id":"421201140000","name":"岔路口派出所"},
  {"id":"421202170000","name":"永安派出所"},
  {"id":"421202180000","name":"十好桥派出所"},
  {"id":"421202190000","name":"浮山派出所"},
  {"id":"421202200000","name":"汀泗派出所"},
  {"id":"421202210000","name":"甘棠派出所"},
  {"id":"421202220000","name":"向阳湖派出所"},
  {"id":"421202230000","name":"官埠桥派出所"},
  {"id":"421202240000","name":"横沟桥派出所"},
  {"id":"421202250000","name":"贺胜桥派出所"},
  {"id":"421202260000","name":"双溪派出所"},
  {"id":"421202270000","name":"高桥派出所"},
  {"id":"421202280000","name":"大幕派出所"},
  {"id":"421202290000","name":"马桥派出所"},
  {"id":"421202300000","name":"桂花派出所"},
  {"id":"421221220000","name":"鱼岳水陆派出所"},
  {"id":"421221230000","name":"方庄派出所"},
  {"id":"421221240000","name":"陆溪口水陆派出所"},
  {"id":"421221250000","name":"高铁岭派出所"},
  {"id":"421221260000","name":"舒桥派出所"},
  {"id":"421221270000","name":"官桥派出所"},
  {"id":"421221280000","name":"新街派出所"},
  {"id":"421221290000","name":"潘家湾水陆派出所"},
  {"id":"421221300000","name":"渡普口派出所"},
  {"id":"421221310000","name":"老官咀派出所"},
  {"id":"421221320000","name":"牌洲湾派出所"},
  {"id":"421221330000","name":"墩头湾派出所"},
  {"id":"421222150000","name":"隽水派出所"},
  {"id":"421222160000","name":"五里派出所"},
  {"id":"421222160100","name":"五里派出所刑侦中队"},
  {"id":"421222170000","name":"马港派出所"},
  {"id":"421222170100","name":"马港派出所刑侦中队"},
  {"id":"421222180000","name":"沙堆派出所"},
  {"id":"421222180100","name":"沙堆派出所刑侦中队"},
  {"id":"421222190000","name":"四庄派出所"},
  {"id":"421222190100","name":"四庄派出所刑侦中队"},
  {"id":"421222200000","name":"关刀派出所"},
  {"id":"421222200100","name":"关刀派出所刑侦中队"},
  {"id":"421222210000","name":"塘湖派出所"},
  {"id":"421222210100","name":"塘湖派出所刑侦中队"},
  {"id":"421222220000","name":"麦市派出所"},
  {"id":"421222220100","name":"麦市派出所刑侦中队"},
  {"id":"421222230000","name":"石南派出所"},
  {"id":"421222230100","name":"石南派出所刑侦中队"},
  {"id":"421222240000","name":"北港派出所"},
  {"id":"421222240100","name":"北港派出所刑侦中队"},
  {"id":"421222250000","name":"大坪派出所"},
  {"id":"421222250100","name":"大坪派出所刑侦中队"},
  {"id":"421222260000","name":"城北派出所"},
  {"id":"421223170000","name":"肖岭派出所"},
  {"id":"421223180000","name":"沙坪派出所"},
  {"id":"421223190000","name":"石城派出所"},
  {"id":"421223200000","name":"桂花泉派出所"},
  {"id":"421223210000","name":"鹿门派出所"},
  {"id":"421223220000","name":"天城派出所"},
  {"id":"421223230000","name":"大桥派出所"},
  {"id":"421223240000","name":"白霓派出所"},
  {"id":"421223250000","name":"路口派出所"},
  {"id":"421223260000","name":"青山派出所"},
  {"id":"421223270000","name":"铜钟派出所"},
  {"id":"421223280000","name":"港口派出所"},
  {"id":"421223290000","name":"金塘派出所"},
  {"id":"421223300000","name":"高枧派出所"},
  {"id":"421224140000","name":"通羊派出所"},
  {"id":"421224150000","name":"南林派出所"},
  {"id":"421224160000","name":"大路派出所"},
  {"id":"421224170000","name":"厦铺派出所"},
  {"id":"421224180000","name":"杨芳派出所"},
  {"id":"421224190000","name":"闯王派出所"},
  {"id":"421224200000","name":"九宫派出所"},
  {"id":"421224210000","name":"洪港派出所"},
  {"id":"421224220000","name":"燕厦派出所"},
  {"id":"421224230000","name":"黄沙派出所"},
  {"id":"421224240000","name":"大畈派出所"},
  {"id":"421224250000","name":"慈口派出所"},
  {"id":"421224260000","name":"九宫山风景名胜区派出所"},
  {"id":"421224270000","name":"通山县公安局西城派出所"},
  {"id":"421281150000","name":"蒲圻派出所"},
  {"id":"421281160000","name":"赤马港派出所"},
  {"id":"421281170000","name":"陆水水陆派出所"},
  {"id":"421281180000","name":"赵李桥派出所"},
  {"id":"421281190000","name":"茶庵派出所"},
  {"id":"421281200000","name":"新店派出所"},
  {"id":"421281210000","name":"官塘派出所"},
  {"id":"421281220000","name":"中伙派出所"},
  {"id":"421281230000","name":"车埠派出所"},
  {"id":"421281240000","name":"柳山派出所"},
  {"id":"421281250000","name":"黄盖湖派出所"},
  {"id":"421281260000","name":"余家桥派出所"},
  {"id":"421281270000","name":"神山派出所"},
  {"id":"421281280000","name":"赤壁镇派出所"},
  {"id":"421302120000","name":"东城派出所"},
  {"id":"421302130000","name":"西城派出所"},
  {"id":"421302140000","name":"南郊派出所"},
  {"id":"421302150000","name":"北郊派出所"},
  {"id":"421302160000","name":"唐镇派出所"},
  {"id":"421302170000","name":"淅河派出所"},
  {"id":"421302180000","name":"厉山派出所"},
  {"id":"421302190000","name":"洪山派出所"},
  {"id":"421302200000","name":"万店派出所"},
  {"id":"421302210000","name":"殷店派出所"},
  {"id":"421302220000","name":"小林派出所"},
  {"id":"421302230000","name":"安居派出所"},
  {"id":"421302240000","name":"淮河派出所"},
  {"id":"421302250000","name":"环潭派出所"},
  {"id":"421302260000","name":"均川派出所"},
  {"id":"421302270000","name":"万和派出所"},
  {"id":"421302280000","name":"何店派出所"},
  {"id":"421302290000","name":"府河派出所"},
  {"id":"421302300000","name":"高城派出所"},
  {"id":"421302310000","name":"岩子河派出所"},
  {"id":"421302320000","name":"天河口派出所"},
  {"id":"421302330000","name":"草店派出所"},
  {"id":"421302340000","name":"吴山派出所"},
  {"id":"421302350000","name":"新城派出所"},
  {"id":"421302360000","name":"尚市派出所"},
  {"id":"421302370000","name":"封江派出所"},
  {"id":"421302380000","name":"新街派出所"},
  {"id":"421302390000","name":"郧阳派出所"},
  {"id":"421302400000","name":"双河派出所"},
  {"id":"421302410000","name":"长岗派出所"},
  {"id":"421302420000","name":"三里岗派出所"},
  {"id":"421302430000","name":"柳林派出所"},
  {"id":"421302440000","name":"洛阳派出所"},
  {"id":"421302450000","name":"大堰坡派出所"},
  {"id":"421302460000","name":"万福店派出所"},
  {"id":"421303050000","name":"湖北省随州市公安局高新园区公安分局淅河派出所"},
  {"id":"421303060000","name":"湖北省随州市公安局高新技术产业园区公安分局白云湖派出所"},
  {"id":"421321230000","name":"湖北省随县公安局厉山派出所"},
  {"id":"421381070000","name":"湖北省广水市公安局广水派出所"},
  {"id":"421381200000","name":"南庙口派出所"},
  {"id":"421381210000","name":"武元桥派出所"},
  {"id":"421381220000","name":"芦兴派出所"},
  {"id":"421381230000","name":"烟厂派出所"},
  {"id":"421381240000","name":"西城派出所"},
  {"id":"421381250000","name":"东城派出所"},
  {"id":"421381260000","name":"永阳派出所"},
  {"id":"421381270000","name":"城郊派出所"},
  {"id":"421381280000","name":"十里派出所"},
  {"id":"421381290000","name":"宝林派出所"},
  {"id":"421381300000","name":"杨寨派出所"},
  {"id":"421381310000","name":"太平派出所"},
  {"id":"421381320000","name":"李店派出所"},
  {"id":"421381330000","name":"兴隆派出所"},
  {"id":"421381340000","name":"余店派出所"},
  {"id":"421381350000","name":"关庙派出所"},
  {"id":"421381360000","name":"平林派出所"},
  {"id":"421381370000","name":"马坪派出所"},
  {"id":"421381380000","name":"长岭派出所"},
  {"id":"421381390000","name":"陈巷派出所"},
  {"id":"421381400000","name":"骆店派出所"},
  {"id":"421381410000","name":"蔡河派出所"},
  {"id":"421381420000","name":"郝店派出所"},
  {"id":"421381430000","name":"吴店派出所"},
  {"id":"421381450000","name":"开发区派出所"},
  {"id":"421381460000","name":"武胜关派出所"},
  {"id":"421381470000","name":"湖北省广水市公安局武胜关派出所"},
  {"id":"421381480000","name":"中华山派出所"},
  {"id":"421381490000","name":"三潭派出所"},
  {"id":"422801180000","name":"舞阳坝派出所"},
  {"id":"422801190000","name":"六角亭派出所"},
  {"id":"422801210000","name":"土桥坝派出所"},
  {"id":"422801220000","name":"红庙派出所"},
  {"id":"422801230000","name":"龙凤坝派出所"},
  {"id":"422801250000","name":"太阳河派出所"},
  {"id":"422801260000","name":"崔坝派出所"},
  {"id":"422801270000","name":"沙地派出所"},
  {"id":"422801280000","name":"七里派出所"},
  {"id":"422801300000","name":"新塘派出所"},
  {"id":"422801310000","name":"双河派出所"},
  {"id":"422801320000","name":"红土派出所"},
  {"id":"422801340000","name":"屯堡派出所"},
  {"id":"422801350000","name":"沐抚派出所"},
  {"id":"422801360000","name":"板桥派出所"},
  {"id":"422801370000","name":"白果派出所"},
  {"id":"422801390000","name":"芭蕉派出所"},
  {"id":"422801400000","name":"黄泥塘派出所"},
  {"id":"422801410000","name":"龙马派出所"},
  {"id":"422801510000","name":"恩施市公安局舞阳坝派出所"},
  {"id":"422801520000","name":"恩施市公安局小渡船派出所"},
  {"id":"422801530000","name":"恩施市公安局土桥坝派出所"},
  {"id":"422801540000","name":"恩施市公安局六角亭派出所"},
  {"id":"422801550000","name":"恩施市公安局红庙派出所"},
  {"id":"422801560000","name":"恩施市公安局七里坪派出所"},
  {"id":"422801570000","name":"恩施市公安局龙凤坝派出所"},
  {"id":"422801580000","name":"恩施市公安局龙马派出所"},
  {"id":"422801590000","name":"恩施市公安局崔坝派出所"},
  {"id":"422801600000","name":"恩施市公安局沙地派出所"},
  {"id":"422801610000","name":"恩施市公安局白杨坪派出所"},
  {"id":"422801620000","name":"恩施市公安局太阳河派出所"},
  {"id":"422801630000","name":"恩施市公安局屯堡派出所"},
  {"id":"422801640000","name":"恩施市公安局沐抚派出所"},
  {"id":"422801650000","name":"恩施市公安局板桥派出所"},
  {"id":"422801660000","name":"恩施市公安局三岔派出所"},
  {"id":"422801670000","name":"恩施市公安局新塘派出所"},
  {"id":"422801680000","name":"恩施市公安局双河派出所"},
  {"id":"422801690000","name":"恩施市公安局红土派出所"},
  {"id":"422801700000","name":"恩施市公安局石窑派出所"},
  {"id":"422801710000","name":"恩施市公安局白果派出所"},
  {"id":"422801720000","name":"恩施市公安局芭蕉派出所"},
  {"id":"422801730000","name":"恩施市公安局黄泥塘派出所"},
  {"id":"422801740000","name":"恩施市公安局盛家坝派出所"},
  {"id":"422802180000","name":"东城派出所"},
  {"id":"422802190000","name":"元堡派出所"},
  {"id":"422802200000","name":"毛坝派出所"},
  {"id":"422802220000","name":"凉务派出所"},
  {"id":"422802230000","name":"忠路派出所"},
  {"id":"422802240000","name":"文斗派出所"},
  {"id":"422802250000","name":"建南派出所"},
  {"id":"422802270000","name":"汪营派出所"},
  {"id":"422802280000","name":"南坪派出所"},
  {"id":"422802290000","name":"柏杨派出所"},
  {"id":"422802510000","name":"利川市公安局都亭派出所"},
  {"id":"422802520000","name":"利川市公安局东城派出所"},
  {"id":"422802530000","name":"利川市公安局团堡派出所"},
  {"id":"422802540000","name":"利川市公安局元堡派出所"},
  {"id":"422802550000","name":"利川市公安局毛坝派出所"},
  {"id":"422802560000","name":"利川市公安局沙溪派出所"},
  {"id":"422802570000","name":"利川市公安局文斗派出所"},
  {"id":"422802580000","name":"利川市公安局忠路派出所"},
  {"id":"422802590000","name":"利川市公安局建南派出所"},
  {"id":"422802600000","name":"利川市公安局谋道派出所"},
  {"id":"422802610000","name":"利川市公安局南坪派出所"},
  {"id":"422802620000","name":"利川市公安局柏杨坝派出所"},
  {"id":"422802630000","name":"利川市公安局凉雾派出所"},
  {"id":"422802640000","name":"利川市公安局汪营派出所"},
  {"id":"422802650000","name":"利川市公安局佛宝山派出所"},
  {"id":"422802660000","name":"利川市公安局城南派出所"},
  {"id":"422822220000","name":"城区派出所"},
  {"id":"422822230000","name":"城郊派出所"},
  {"id":"422822240000","name":"长梁派出所"},
  {"id":"422822260000","name":"茅田派出所"},
  {"id":"422822270000","name":"龙坪派出所"},
  {"id":"422822280000","name":"高坪派出所"},
  {"id":"422822290000","name":"三里派出所"},
  {"id":"422822310000","name":"花坪派出所"},
  {"id":"422822320000","name":"景阳派出所"},
  {"id":"422822330000","name":"官店派出所"},
  {"id":"422822610000","name":"建始县公安局业州城区派出所"},
  {"id":"422822620000","name":"建始县业州城郊派出所"},
  {"id":"422822630000","name":"建始县公安局长梁派出所"},
  {"id":"422822640000","name":"建始县公安局天生派出所"},
  {"id":"422822650000","name":"建始县公安局茅田派出所"},
  {"id":"422822660000","name":"建始县公安局龙坪派出所"},
  {"id":"422822670000","name":"建始县公安局高坪派出所"},
  {"id":"422822680000","name":"建始县公安局三里派出所"},
  {"id":"422822690000","name":"建始县公安局红岩派出所"},
  {"id":"422822700000","name":"建始县公安局花坪派出所"},
  {"id":"422822710000","name":"建始县公安局景阳派出所"},
  {"id":"422822720000","name":"建始县公安局官店派出所"},
  {"id":"422822730000","name":"建始县公安局广润派出所"},
  {"id":"422823160000","name":"东壤口派出所"},
  {"id":"422823170000","name":"溪丘湾派出所"},
  {"id":"422823180000","name":"沿渡河派出所"},
  {"id":"422823190000","name":"官渡口派出所"},
  {"id":"422823210000","name":"绿葱坡派出所"},
  {"id":"422823220000","name":"大支坪派出所"},
  {"id":"422823230000","name":"野三关派出所"},
  {"id":"422823240000","name":"清太坪派出所"},
  {"id":"422823250000","name":"水布垭派出所"},
  {"id":"422823260000","name":"金果坪派出所"},
  {"id":"422823270000","name":"水上旅游派出所"},
  {"id":"422823280000","name":"水布垭工区派出所"},
  {"id":"422823510000","name":"巴东县公安局野三关派出所"},
  {"id":"422823520000","name":"巴东县公安局信陵派出所"},
  {"id":"422823530000","name":"巴东县公安局沿渡河派出所"},
  {"id":"422823540000","name":"巴东县公安局官渡口派出所"},
  {"id":"422823550000","name":"巴东县公安局茶店子派出所"},
  {"id":"422823560000","name":"巴东县公安局绿葱坡派出所"},
  {"id":"422823570000","name":"巴东县公安局清太坪派出所"},
  {"id":"422823580000","name":"巴东县公安局东壤口派出所"},
  {"id":"422823590000","name":"巴东县公安局大支坪派出所"},
  {"id":"422823600000","name":"巴东县公安局水布垭派出所"},
  {"id":"422823610000","name":"巴东县公安局溪丘湾派出所"},
  {"id":"422823620000","name":"巴东县公安局金果坪派出所"},
  {"id":"422823630000","name":"巴东县公安局水布垭工区派出所"},
  {"id":"422823640000","name":"巴东县公安局水上旅游派出所"},
  {"id":"422825160000","name":"珠山派出所"},
  {"id":"422825170000","name":"椒园派出所"},
  {"id":"422825180000","name":"晓关派出所"},
  {"id":"422825190000","name":"万寨派出所"},
  {"id":"422825200000","name":"长潭河派出所"},
  {"id":"422825210000","name":"椿木营派出所"},
  {"id":"422825220000","name":"沙道沟派出所"},
  {"id":"422825230000","name":"李家河派出所"},
  {"id":"422825240000","name":"高罗派出所"},
  {"id":"422825250000","name":"龙洞派出所"},
  {"id":"422825510000","name":"宣恩县公安局珠山派出所"},
  {"id":"422825520000","name":"宣恩县公安局椒园派出所"},
  {"id":"422825530000","name":"宣恩县公安局沙道沟派出所"},
  {"id":"422825540000","name":"宣恩县公安局晓关派出所"},
  {"id":"422825550000","name":"宣恩县公安局长潭河派出所"},
  {"id":"422825560000","name":"宣恩县公安局万寨派出所"},
  {"id":"422825570000","name":"宣恩县公安局椿木营派出所"},
  {"id":"422825580000","name":"宣恩县公安局高罗派出所"},
  {"id":"422825590000","name":"宣恩县公安局李家河派出所"},
  {"id":"422826150000","name":"高乐山派出所"},
  {"id":"422826160000","name":"忠堡派出所"},
  {"id":"422826170000","name":"清坪派出所"},
  {"id":"422826180000","name":"活龙派出所"},
  {"id":"422826190000","name":"尖山派出所"},
  {"id":"422826200000","name":"小村派出所"},
  {"id":"422826210000","name":"黄金洞派出所"},
  {"id":"422826220000","name":"丁寨派出所"},
  {"id":"422826230000","name":"甲马池派出所"},
  {"id":"422826240000","name":"朝阳寺派出所"},
  {"id":"422826250000","name":"大路坝派出所"},
  {"id":"422826260000","name":"咸丰县公安局大路坝派出所"},
  {"id":"422827130000","name":"翔凤派出所"},
  {"id":"422827140000","name":"接龙派出所"},
  {"id":"422827150000","name":"绿水派出所"},
  {"id":"422827160000","name":"漫水派出所"},
  {"id":"422827170000","name":"百福司派出所"},
  {"id":"422827180000","name":"三胡派出所"},
  {"id":"422827190000","name":"革勒车派出所"},
  {"id":"422827200000","name":"高洞派出所"},
  {"id":"422827210000","name":"旧司派出所"},
  {"id":"422827220000","name":"大河派出所"},
  {"id":"422827610000","name":"来凤县公安局翔凤派出所"},
  {"id":"422827620000","name":"来凤县公安局桂花派出所"},
  {"id":"422827630000","name":"来凤县公安局接龙桥派出所"},
  {"id":"422827640000","name":"来凤县公安局绿水派出所"},
  {"id":"422827650000","name":"来凤县公安局漫水派出所"},
  {"id":"422827660000","name":"来凤县公安局百福司派出所"},
  {"id":"422827670000","name":"来凤县公安局大河派出所"},
  {"id":"422827680000","name":"来凤县公安局旧司派出所"},
  {"id":"422827690000","name":"来凤县公安局三胡派出所"},
  {"id":"422827700000","name":"来凤县公安局革勒车派出所"},
  {"id":"422828130000","name":"走马派出所"},
  {"id":"422828140000","name":"铁炉派出所"},
  {"id":"422828150000","name":"五里派出所"},
  {"id":"422828160000","name":"燕子派出所"},
  {"id":"422828170000","name":"下坪派出所"},
  {"id":"422828180000","name":"邬阳派出所"},
  {"id":"422828190000","name":"中营派出所"},
  {"id":"422828200000","name":"容美派出所"},
  {"id":"422828210000","name":"太平派出所"},
  {"id":"422828220000","name":"北佳派出所"},
  {"id":"422828610000","name":"鹤峰县公安局容美派出所"},
  {"id":"422828620000","name":"鹤峰县公安局铁炉派出所"},
  {"id":"422828630000","name":"鹤峰县公安局走马派出所"},
  {"id":"422828640000","name":"鹤峰县公安局五里派出所"},
  {"id":"422828650000","name":"鹤峰县公安局燕子派出所"},
  {"id":"422828660000","name":"鹤峰县公安局中营派出所"},
  {"id":"422828670000","name":"鹤峰县公安局下坪派出所"},
  {"id":"422828680000","name":"鹤峰县公安局邬阳派出所"},
  {"id":"422828690000","name":"鹤峰县公安局太平派出所"},
  {"id":"429004210000","name":"干河水陆派出所"},
  {"id":"429004220000","name":"龙华山派出所"},
  {"id":"429004230000","name":"沙嘴派出所"},
  {"id":"429004240000","name":"工业园派出所"},
  {"id":"429004250000","name":"郑场派出所"},
  {"id":"429004260000","name":"毛嘴派出所"},
  {"id":"429004270000","name":"剅河派出所"},
  {"id":"429004280000","name":"三伏潭派出所"},
  {"id":"429004290000","name":"胡场派出所"},
  {"id":"429004300000","name":"长淌口派出所"},
  {"id":"429004310000","name":"西流河派出所"},
  {"id":"429004320000","name":"彭场水陆派出所"},
  {"id":"429004330000","name":"沙湖水陆派出所"},
  {"id":"429004340000","name":"杨林尾水陆派出所"},
  {"id":"429004350000","name":"张沟派出所"},
  {"id":"429004360000","name":"郭河派出所"},
  {"id":"429004370000","name":"沔城派出所"},
  {"id":"429004380000","name":"通海口派出所"},
  {"id":"429004390000","name":"陈场派出所"},
  {"id":"429004400000","name":"仙桃市公安局排湖风景区派出所"},
  {"id":"429005421000","name":"湖北省江汉油田公安局广华派出所"},
  {"id":"429005422000","name":"湖北省江汉油田公安局向阳派出所"},
  {"id":"429005423000","name":"湖北省江汉油田公安局五七派出所"},
  {"id":"429005424000","name":"湖北省江汉油田公安局红旗派出所"},
  {"id":"429005710000","name":"园林派出所"},
  {"id":"429005720000","name":"泽口水陆派出所"},
  {"id":"429005730000","name":"竹根滩派出所"},
  {"id":"429005740000","name":"杨市派出所"},
  {"id":"429005750000","name":"渔洋水陆派出所"},
  {"id":"429005760000","name":"老新水陆派出所"},
  {"id":"429005770000","name":"张金水陆派出所"},
  {"id":"429005780000","name":"龙湾派出所"},
  {"id":"429005790000","name":"熊口水陆派出所"},
  {"id":"429005800000","name":"浩口水陆派出所"},
  {"id":"429005810000","name":"周矶派出所"},
  {"id":"429005820000","name":"王场派出所"},
  {"id":"429005830000","name":"高石碑派出所"},
  {"id":"429005840000","name":"积玉口派出所"},
  {"id":"429005850000","name":"广华寺派出所"},
  {"id":"429005860000","name":"总口派出所"},
  {"id":"429005870000","name":"西大垸派出所"},
  {"id":"429005880000","name":"运粮湖派出所"},
  {"id":"429005890000","name":"后湖派出所"},
  {"id":"429005900000","name":"金熊派出所"},
  {"id":"429005910000","name":"高场派出所"},
  {"id":"429005920000","name":"兴隆派出所"},
  {"id":"429005930000","name":"泰丰派出所"},
  {"id":"429006200000","name":"竟陵派出所"},
  {"id":"429006210000","name":"岳口派出所"},
  {"id":"429006220000","name":"皂市派出所"},
  {"id":"429006230000","name":"张港派出所"},
  {"id":"429006240000","name":"杨林派出所"},
  {"id":"429006250000","name":"候口派出所"},
  {"id":"429006260000","name":"渔薪派出所"},
  {"id":"429006270000","name":"彭市派出所"},
  {"id":"429006280000","name":"干一派出所"},
  {"id":"429006290000","name":"蒋场派出所"},
  {"id":"429006300000","name":"多宝派出所"},
  {"id":"429006310000","name":"拖市派出所"},
  {"id":"429006320000","name":"汪场派出所"},
  {"id":"429006330000","name":"黄潭派出所"},
  {"id":"429006340000","name":"白茅湖派出所"},
  {"id":"429006350000","name":"横林派出所"},
  {"id":"429006360000","name":"麻洋派出所"},
  {"id":"429006370000","name":"多祥派出所"},
  {"id":"429006380000","name":"马湾派出所"},
  {"id":"429006390000","name":"小板派出所"},
  {"id":"429006400000","name":"净潭派出所"},
  {"id":"429006410000","name":"卢市派出所"},
  {"id":"429006420000","name":"胡市派出所"},
  {"id":"429006430000","name":"九真派出所"},
  {"id":"429006440000","name":"石河派出所"},
  {"id":"429006450000","name":"佛子山派出所"},
  {"id":"429006460000","name":"蒋湖派出所"},
  {"id":"429006470000","name":"沉湖派出所"},
  {"id":"429021610000","name":"松柏派出所"},
  {"id":"429021620000","name":"木鱼派出所"},
  {"id":"429021630000","name":"阳日派出所"},
  {"id":"429021640000","name":"宋洛派出所"},
  {"id":"429021650000","name":"红坪派出所"},
  {"id":"429021660000","name":"新华派出所"},
  {"id":"429021670000","name":"下谷坪派出所"},
  {"id":"429021680000","name":"大九湖派出所"},
  {"id":"429021690000","name":"机场派出所"}
]
/**
 * 签注种类
 */
export const crjApplyType = [
  {"value":"11","label":"赴港澳探亲签注"},
  {"value":"12","label":"赴港澳团队旅游签注"},
  {"value":"13","label":"赴港澳商务签注"},
  {"value":"19","label":"赴港澳其他签注"},
  {"value":"1B","label":"赴港澳个人旅游签注"},
  {"value":"1G","label":"赴港澳逗留签注"},
  {"value":"1J","label":"赴香港迪士尼团队旅游签注"},
  {"value":"21","label":"赴台探亲"},
  {"value":"22","label":"赴台应邀"},
  {"value":"23","label":"赴台定居"},
  {"value":"25","label":"赴台旅游"},
  {"value":"26","label":"赴台乘务"},
  {"value":"27","label":"赴台商务"},
  {"value":"29","label":"赴台其他"},
  {"value":"2A","label":"赴台就学"},
  {"value":"2B","label":"赴台个人旅游"}
]

